$(function () {

    function checkCookieMarked(cName) {
        var name = cName + "=", accepted = false;
        var cArr = document.cookie.split(';');
        for (var i = 0; i < cArr.length; i++) {
            var c = cArr[i].trim();
            if (c.indexOf(name) == 0) {
                accepted = true;
            }
        }
        if (accepted == false) {
            $('#cookie-wrapper').show();
            $('.accept-cookie').on('click', function () {
                var date = new Date();
                var expirary = new Date();
                expirary.setYear(date.getFullYear() + 1);
                setCookieItem("accept_cookie_toolkit", "true", expirary, "/", "", false);
                $('#cookie-wrapper').animate({
                    height: 0
                }, 250, function () {
                    $(this).remove();
                });
            });
        }
    }
    checkCookieMarked("accept_cookie_toolkit");

    function setCookieItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
        var sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
    }

});
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
!(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    factory(require('jquery'));
  } else {
    factory(root.jQuery);
  }
})(this, function($) {

  'use strict';

  /**
   * Name of the plugin
   * @private
   * @const
   * @type {String}
   */
  var PLUGIN_NAME = 'vide';

  /**
   * Default settings
   * @private
   * @const
   * @type {Object}
   */
  var DEFAULTS = {
    volume: 1,
    playbackRate: 1,
    muted: true,
    loop: true,
    autoplay: true,
    position: '50% 50%',
    posterType: 'detect',
    resizing: true,
    bgColor: 'transparent',
    className: ''
  };

  /**
   * Not implemented error message
   * @private
   * @const
   * @type {String}
   */
  var NOT_IMPLEMENTED_MSG = 'Not implemented';

  /**
   * Parse a string with options
   * @private
   * @param {String} str
   * @returns {Object|String}
   */
  function parseOptions(str) {
    var obj = {};
    var delimiterIndex;
    var option;
    var prop;
    var val;
    var arr;
    var len;
    var i;

    // Remove spaces around delimiters and split
    arr = str.replace(/\s*:\s*/g, ':').replace(/\s*,\s*/g, ',').split(',');

    // Parse a string
    for (i = 0, len = arr.length; i < len; i++) {
      option = arr[i];

      // Ignore urls and a string without colon delimiters
      if (
        option.search(/^(http|https|ftp):\/\//) !== -1 ||
        option.search(':') === -1
      ) {
        break;
      }

      delimiterIndex = option.indexOf(':');
      prop = option.substring(0, delimiterIndex);
      val = option.substring(delimiterIndex + 1);

      // If val is an empty string, make it undefined
      if (!val) {
        val = undefined;
      }

      // Convert a string value if it is like a boolean
      if (typeof val === 'string') {
        val = val === 'true' || (val === 'false' ? false : val);
      }

      // Convert a string value if it is like a number
      if (typeof val === 'string') {
        val = !isNaN(val) ? +val : val;
      }

      obj[prop] = val;
    }

    // If nothing is parsed
    if (prop == null && val == null) {
      return str;
    }

    return obj;
  }

  /**
   * Parse a position option
   * @private
   * @param {String} str
   * @returns {Object}
   */
  function parsePosition(str) {
    str = '' + str;

    // Default value is a center
    var args = str.split(/\s+/);
    var x = '50%';
    var y = '50%';
    var len;
    var arg;
    var i;

    for (i = 0, len = args.length; i < len; i++) {
      arg = args[i];

      // Convert values
      if (arg === 'left') {
        x = '0%';
      } else if (arg === 'right') {
        x = '100%';
      } else if (arg === 'top') {
        y = '0%';
      } else if (arg === 'bottom') {
        y = '100%';
      } else if (arg === 'center') {
        if (i === 0) {
          x = '50%';
        } else {
          y = '50%';
        }
      } else {
        if (i === 0) {
          x = arg;
        } else {
          y = arg;
        }
      }
    }

    return { x: x, y: y };
  }

  /**
   * Search a poster
   * @private
   * @param {String} path
   * @param {Function} callback
   */
  function findPoster(path, callback) {
    var onLoad = function() {
      callback(this.src);
    };

    $('<img src="' + path + '.gif">').on('load', onLoad);
    $('<img src="' + path + '.jpg">').on('load', onLoad);
    $('<img src="' + path + '.jpeg">').on('load', onLoad);
    $('<img src="' + path + '.png">').on('load', onLoad);
  }

  /**
   * Vide constructor
   * @param {HTMLElement} element
   * @param {Object|String} path
   * @param {Object|String} options
   * @constructor
   */
  function Vide(element, path, options) {
    this.$element = $(element);

    // Parse path
    if (typeof path === 'string') {
      path = parseOptions(path);
    }

    // Parse options
    if (!options) {
      options = {};
    } else if (typeof options === 'string') {
      options = parseOptions(options);
    }

    // Remove an extension
    if (typeof path === 'string') {
      path = path.replace(/\.\w*$/, '');
    } else if (typeof path === 'object') {
      for (var i in path) {
        if (path.hasOwnProperty(i)) {
          path[i] = path[i].replace(/\.\w*$/, '');
        }
      }
    }

    this.settings = $.extend({}, DEFAULTS, options);
    this.path = path;

    // https://github.com/VodkaBears/Vide/issues/110
    try {
      this.init();
    } catch (e) {
      if (e.message !== NOT_IMPLEMENTED_MSG) {
        throw e;
      }
    }
  }

  /**
   * Initialization
   * @public
   */
  Vide.prototype.init = function() {
    var vide = this;
    var path = vide.path;
    var poster = path;
    var sources = '';
    var $element = vide.$element;
    var settings = vide.settings;
    var position = parsePosition(settings.position);
    var posterType = settings.posterType;
    var $video;
    var $wrapper;

    // Set styles of a video wrapper
    $wrapper = vide.$wrapper = $('<div>')
      .addClass(settings.className)
      .css({
        position: 'absolute',
        'z-index': -1,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        overflow: 'hidden',
        '-webkit-background-size': 'cover',
        '-moz-background-size': 'cover',
        '-o-background-size': 'cover',
        'background-size': 'cover',
        'background-color': settings.bgColor,
        'background-repeat': 'no-repeat',
        'background-position': position.x + ' ' + position.y
      });

    // Get a poster path
    if (typeof path === 'object') {
      if (path.poster) {
        poster = path.poster;
      } else {
        if (path.mp4) {
          poster = path.mp4;
        } else if (path.webm) {
          poster = path.webm;
        } else if (path.ogv) {
          poster = path.ogv;
        }
      }
    }

    // Set a video poster
    if (posterType === 'detect') {
      findPoster(poster, function(url) {
        $wrapper.css('background-image', 'url(' + url + ')');
      });
    } else if (posterType !== 'none') {
      $wrapper.css('background-image', 'url(' + poster + '.' + posterType + ')');
    }

    // If a parent element has a static position, make it relative
    if ($element.css('position') === 'static') {
      $element.css('position', 'relative');
    }

    $element.prepend($wrapper);

    if (typeof path === 'object') {
      if (path.mp4) {
        sources += '<source src="' + path.mp4 + '.mp4" type="video/mp4">';
      }

      if (path.webm) {
        sources += '<source src="' + path.webm + '.webm" type="video/webm">';
      }

      if (path.ogv) {
        sources += '<source src="' + path.ogv + '.ogv" type="video/ogg">';
      }

      $video = vide.$video = $('<video>' + sources + '</video>');
    } else {
      $video = vide.$video = $('<video>' +
        '<source src="' + path + '.mp4" type="video/mp4">' +
        '<source src="' + path + '.webm" type="video/webm">' +
        '<source src="' + path + '.ogv" type="video/ogg">' +
        '</video>');
    }

    // https://github.com/VodkaBears/Vide/issues/110
    try {
      $video

        // Set video properties
        .prop({
          autoplay: settings.autoplay,
          loop: settings.loop,
          volume: settings.volume,
          muted: settings.muted,
          defaultMuted: settings.muted,
          playbackRate: settings.playbackRate,
          defaultPlaybackRate: settings.playbackRate
        });
    } catch (e) {
      throw new Error(NOT_IMPLEMENTED_MSG);
    }

    // Video alignment
    $video.css({
      margin: 'auto',
      position: 'absolute',
      'z-index': -1,
      top: position.y,
      left: position.x,
      '-webkit-transform': 'translate(-' + position.x + ', -' + position.y + ')',
      '-ms-transform': 'translate(-' + position.x + ', -' + position.y + ')',
      '-moz-transform': 'translate(-' + position.x + ', -' + position.y + ')',
      transform: 'translate(-' + position.x + ', -' + position.y + ')',

      // Disable visibility, while loading
      //visibility: 'hidden',
      //opacity: 0
    })

    // Resize a video, when it's loaded
    .one('canplaythrough.' + PLUGIN_NAME, function() {
      vide.resize();
    })

    // Make it visible, when it's already playing
    .one('playing.' + PLUGIN_NAME, function() {
      $video.css({
        visibility: 'visible',
        opacity: 1
      });
      $wrapper.css('background-image', 'none');
    });

    // Resize event is available only for 'window'
    // Use another code solutions to detect DOM elements resizing
    $element.on('resize.' + PLUGIN_NAME, function() {
      if (settings.resizing) {
        vide.resize();
      }
    });

    // Append a video
    $wrapper.append($video);
  };

  /**
   * Get a video element
   * @public
   * @returns {HTMLVideoElement}
   */
  Vide.prototype.getVideoObject = function() {
    return this.$video[0];
  };

  /**
   * Resize a video background
   * @public
   */
  Vide.prototype.resize = function() {
    if (!this.$video) {
      return;
    }

    var $wrapper = this.$wrapper;
    var $video = this.$video;
    var video = $video[0];

    // Get a native video size
    var videoHeight = video.videoHeight;
    var videoWidth = video.videoWidth;

    // Get a wrapper size
    var wrapperHeight = $wrapper.height();
    var wrapperWidth = $wrapper.width();

    if (wrapperWidth / videoWidth > wrapperHeight / videoHeight) {
      $video.css({

        // +2 pixels to prevent an empty space after transformation
        width: wrapperWidth + 2,
        height: 'auto'
      });
    } else {
      $video.css({
        width: 'auto',

        // +2 pixels to prevent an empty space after transformation
        height: wrapperHeight + 2
      });
    }
  };

  /**
   * Destroy a video background
   * @public
   */
  Vide.prototype.destroy = function() {
    delete $[PLUGIN_NAME].lookup[this.index];
    this.$video && this.$video.off(PLUGIN_NAME);
    this.$element.off(PLUGIN_NAME).removeData(PLUGIN_NAME);
    this.$wrapper.remove();
  };

  /**
   * Special plugin object for instances.
   * @public
   * @type {Object}
   */
  $[PLUGIN_NAME] = {
    lookup: []
  };

  /**
   * Plugin constructor
   * @param {Object|String} path
   * @param {Object|String} options
   * @returns {JQuery}
   * @constructor
   */
  $.fn[PLUGIN_NAME] = function(path, options) {
    var instance;

    this.each(function() {
      instance = $.data(this, PLUGIN_NAME);

      // Destroy the plugin instance if exists
      instance && instance.destroy();

      // Create the plugin instance
      instance = new Vide(this, path, options);
      instance.index = $[PLUGIN_NAME].lookup.push(instance) - 1;
      $.data(this, PLUGIN_NAME, instance);
    });

    return this;
  };

  $(document).ready(function() {
    var $window = $(window);

    // Window resize event listener
    $window.on('resize.' + PLUGIN_NAME, function() {
      for (var len = $[PLUGIN_NAME].lookup.length, i = 0, instance; i < len; i++) {
        instance = $[PLUGIN_NAME].lookup[i];

        if (instance && instance.settings.resizing) {
          instance.resize();
        }
      }
    });

    // https://github.com/VodkaBears/Vide/issues/68
    $window.on('unload.' + PLUGIN_NAME, function() {
      return false;
    });

    // Auto initialization
    // Add 'data-vide-bg' attribute with a path to the video without extension
    // Also you can pass options throw the 'data-vide-options' attribute
    // 'data-vide-options' must be like 'muted: false, volume: 0.5'
    $(document).find('[data-' + PLUGIN_NAME + '-bg]').each(function(i, element) {
      var $element = $(element);
      var options = $element.data(PLUGIN_NAME + '-options');
      var path = $element.data(PLUGIN_NAME + '-bg');

      $element[PLUGIN_NAME](path, options);
    });
  });

});

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Jump = factory());
}(this, (function () { 'use strict';

// Robert Penner's easeInOutQuad

// find the rest of his easing functions here: http://robertpenner.com/easing/
// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js

var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var jumper = function jumper() {
  // private variable cache
  // no variables are created during a jump, preventing memory leaks

  var element = void 0; // element to scroll to                   (node)

  var start = void 0; // where scroll starts                    (px)
  var stop = void 0; // where scroll stops                     (px)

  var offset = void 0; // adjustment from the stop position      (px)
  var easing = void 0; // easing function                        (function)
  var a11y = void 0; // accessibility support flag             (boolean)

  var distance = void 0; // distance of scroll                     (px)
  var duration = void 0; // scroll duration                        (ms)

  var timeStart = void 0; // time scroll started                    (ms)
  var timeElapsed = void 0; // time spent scrolling thus far          (ms)

  var next = void 0; // next scroll position                   (px)

  var callback = void 0; // to call when done scrolling            (function)

  // scroll position helper

  function location() {
    return window.scrollY || window.pageYOffset;
  }

  // element offset helper

  function top(element) {
    return element.getBoundingClientRect().top + start;
  }

  // rAF loop helper

  function loop(timeCurrent) {
    // store time scroll started, if not started already
    if (!timeStart) {
      timeStart = timeCurrent;
    }

    // determine time spent scrolling so far
    timeElapsed = timeCurrent - timeStart;

    // calculate next scroll position
    next = easing(timeElapsed, start, distance, duration);

    // scroll to it
    window.scrollTo(0, next);

    // check progress
    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
    : done(); // scrolling is done
  }

  // scroll finished helper

  function done() {
    // account for rAF time rounding inaccuracies
    window.scrollTo(0, start + distance);

    // if scrolling to an element, and accessibility is enabled
    if (element && a11y) {
      // add tabindex indicating programmatic focus
      element.setAttribute('tabindex', '-1');

      // focus the element
      element.focus();
    }

    // if it exists, fire the callback
    if (typeof callback === 'function') {
      callback();
    }

    // reset time for next jump
    timeStart = false;
  }

  // API

  function jump(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // resolve options, or use defaults
    duration = options.duration || 1000;
    offset = options.offset || 0;
    callback = options.callback; // "undefined" is a suitable default, and won't be called
    easing = options.easing || easeInOutQuad;
    a11y = options.a11y || false;

    // cache starting position
    start = location();

    // resolve target
    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
      // scroll from current position
      case 'number':
        element = undefined; // no element to scroll to
        a11y = false; // make sure accessibility is off
        stop = start + target;
        break;

      // scroll to element (node)
      // bounding rect is relative to the viewport
      case 'object':
        element = target;
        stop = top(element);
        break;

      // scroll to element (selector)
      // bounding rect is relative to the viewport
      case 'string':
        element = document.querySelector(target);
        stop = top(element);
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    // resolve duration
    switch (_typeof(options.duration)) {
      // number in ms
      case 'number':
        duration = options.duration;
        break;

      // function passed the distance of the scroll
      case 'function':
        duration = options.duration(distance);
        break;
    }

    // start the loop
    window.requestAnimationFrame(loop);
  }

  // expose only the jump method
  return jump;
};

// export singleton

var singleton = jumper();

return singleton;

})));

/*!
 * Lightbox v2.10.0
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright 2007, 2018 Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */

// Uses Node, AMD or browser globals to create a module.
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (root is window)
        root.lightbox = factory(root.jQuery);
    }
}(this, function ($) {

  function Lightbox(options) {
    this.album = [];
    this.currentImageIndex = void 0;
    this.init();

    // options
    this.options = $.extend({}, this.constructor.defaults);
    this.option(options);
  }

  // Descriptions of all options available on the demo site:
  // http://lokeshdhakar.com/projects/lightbox2/index.html#options
  Lightbox.defaults = {
    albumLabel: 'Image %1 of %2',
    alwaysShowNavOnTouchDevices: false,
    fadeDuration: 600,
    fitImagesInViewport: true,
    imageFadeDuration: 600,
    // maxWidth: 800,
    // maxHeight: 600,
    positionFromTop: 50,
    resizeDuration: 700,
    showImageNumberLabel: true,
    wrapAround: false,
    disableScrolling: false,
    /*
    Sanitize Title
    If the caption data is trusted, for example you are hardcoding it in, then leave this to false.
    This will free you to add html tags, such as links, in the caption.

    If the caption data is user submitted or from some other untrusted source, then set this to true
    to prevent xss and other injection attacks.
     */
    sanitizeTitle: false
  };

  Lightbox.prototype.option = function(options) {
    $.extend(this.options, options);
  };

  Lightbox.prototype.imageCountLabel = function(currentImageNum, totalImages) {
    return this.options.albumLabel.replace(/%1/g, currentImageNum).replace(/%2/g, totalImages);
  };

  Lightbox.prototype.init = function() {
    var self = this;
    // Both enable and build methods require the body tag to be in the DOM.
    $(document).ready(function() {
      self.enable();
      self.build();
    });
  };

  // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
  // that contain 'lightbox'. When these are clicked, start lightbox.
  Lightbox.prototype.enable = function() {
    var self = this;
    $('body').on('click', 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function(event) {
      self.start($(event.currentTarget));
      return false;
    });
  };

  // Build html for the lightbox and the overlay.
  // Attach event handlers to the new DOM elements. click click click
  Lightbox.prototype.build = function() {
    if ($('#lightbox').length > 0) {
        return;
    }

    var self = this;
    $('<div id="lightboxOverlay" class="lightboxOverlay"></div><div id="lightbox" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" /><div class="lb-nav"><a class="lb-prev" href="" ></a><a class="lb-next" href="" ></a></div><div class="lb-loader"><a class="lb-cancel"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close"></a></div></div></div></div>').appendTo($('body'));

    // Cache jQuery objects
    this.$lightbox       = $('#lightbox');
    this.$overlay        = $('#lightboxOverlay');
    this.$outerContainer = this.$lightbox.find('.lb-outerContainer');
    this.$container      = this.$lightbox.find('.lb-container');
    this.$image          = this.$lightbox.find('.lb-image');
    this.$nav            = this.$lightbox.find('.lb-nav');

    // Store css values for future lookup
    this.containerPadding = {
      top: parseInt(this.$container.css('padding-top'), 10),
      right: parseInt(this.$container.css('padding-right'), 10),
      bottom: parseInt(this.$container.css('padding-bottom'), 10),
      left: parseInt(this.$container.css('padding-left'), 10)
    };

    this.imageBorderWidth = {
      top: parseInt(this.$image.css('border-top-width'), 10),
      right: parseInt(this.$image.css('border-right-width'), 10),
      bottom: parseInt(this.$image.css('border-bottom-width'), 10),
      left: parseInt(this.$image.css('border-left-width'), 10)
    };

    // Attach event handlers to the newly minted DOM elements
    this.$overlay.hide().on('click', function() {
      self.end();
      return false;
    });

    this.$lightbox.hide().on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$outerContainer.on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$lightbox.find('.lb-prev').on('click', function() {
      if (self.currentImageIndex === 0) {
        self.changeImage(self.album.length - 1);
      } else {
        self.changeImage(self.currentImageIndex - 1);
      }
      return false;
    });

    this.$lightbox.find('.lb-next').on('click', function() {
      if (self.currentImageIndex === self.album.length - 1) {
        self.changeImage(0);
      } else {
        self.changeImage(self.currentImageIndex + 1);
      }
      return false;
    });

    /*
      Show context menu for image on right-click

      There is a div containing the navigation that spans the entire image and lives above of it. If
      you right-click, you are right clicking this div and not the image. This prevents users from
      saving the image or using other context menu actions with the image.

      To fix this, when we detect the right mouse button is pressed down, but not yet clicked, we
      set pointer-events to none on the nav div. This is so that the upcoming right-click event on
      the next mouseup will bubble down to the image. Once the right-click/contextmenu event occurs
      we set the pointer events back to auto for the nav div so it can capture hover and left-click
      events as usual.
     */
    this.$nav.on('mousedown', function(event) {
      if (event.which === 3) {
        self.$nav.css('pointer-events', 'none');

        self.$lightbox.one('contextmenu', function() {
          setTimeout(function() {
              this.$nav.css('pointer-events', 'auto');
          }.bind(self), 0);
        });
      }
    });


    this.$lightbox.find('.lb-loader, .lb-close').on('click', function() {
      self.end();
      return false;
    });
  };

  // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
  Lightbox.prototype.start = function($link) {
    var self    = this;
    var $window = $(window);

    $window.on('resize', $.proxy(this.sizeOverlay, this));

    $('select, object, embed').css({
      visibility: 'hidden'
    });

    this.sizeOverlay();

    this.album = [];
    var imageNumber = 0;

    function addToAlbum($link) {
      self.album.push({
        alt: $link.attr('data-alt'),
        link: $link.attr('href'),
        title: $link.attr('data-title') || $link.attr('title')
      });
    }

    // Support both data-lightbox attribute and rel attribute implementations
    var dataLightboxValue = $link.attr('data-lightbox');
    var $links;

    if (dataLightboxValue) {
      $links = $($link.prop('tagName') + '[data-lightbox="' + dataLightboxValue + '"]');
      for (var i = 0; i < $links.length; i = ++i) {
        addToAlbum($($links[i]));
        if ($links[i] === $link[0]) {
          imageNumber = i;
        }
      }
    } else {
      if ($link.attr('rel') === 'lightbox') {
        // If image is not part of a set
        addToAlbum($link);
      } else {
        // If image is part of a set
        $links = $($link.prop('tagName') + '[rel="' + $link.attr('rel') + '"]');
        for (var j = 0; j < $links.length; j = ++j) {
          addToAlbum($($links[j]));
          if ($links[j] === $link[0]) {
            imageNumber = j;
          }
        }
      }
    }

    // Position Lightbox
    var top  = $window.scrollTop() + this.options.positionFromTop;
    var left = $window.scrollLeft();
    this.$lightbox.css({
      top: top + 'px',
      left: left + 'px'
    }).fadeIn(this.options.fadeDuration);

    // Disable scrolling of the page while open
    if (this.options.disableScrolling) {
      $('html').addClass('lb-disable-scrolling');
    }

    this.changeImage(imageNumber);
  };

  // Hide most UI elements in preparation for the animated resizing of the lightbox.
  Lightbox.prototype.changeImage = function(imageNumber) {
    var self = this;

    this.disableKeyboardNav();
    var $image = this.$lightbox.find('.lb-image');

    this.$overlay.fadeIn(this.options.fadeDuration);

    $('.lb-loader').fadeIn('slow');
    this.$lightbox.find('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption').hide();

    this.$outerContainer.addClass('animating');

    // When image to show is preloaded, we send the width and height to sizeContainer()
    var preloader = new Image();
    preloader.onload = function() {
      var $preloader;
      var imageHeight;
      var imageWidth;
      var maxImageHeight;
      var maxImageWidth;
      var windowHeight;
      var windowWidth;

      $image.attr({
        'alt': self.album[imageNumber].alt,
        'src': self.album[imageNumber].link
      });

      $preloader = $(preloader);

      $image.width(preloader.width);
      $image.height(preloader.height);

      if (self.options.fitImagesInViewport) {
        // Fit image inside the viewport.
        // Take into account the border around the image and an additional 10px gutter on each side.

        windowWidth    = $(window).width();
        windowHeight   = $(window).height();
        maxImageWidth  = windowWidth - self.containerPadding.left - self.containerPadding.right - self.imageBorderWidth.left - self.imageBorderWidth.right - 20;
        maxImageHeight = windowHeight - self.containerPadding.top - self.containerPadding.bottom - self.imageBorderWidth.top - self.imageBorderWidth.bottom - 120;

        // Check if image size is larger then maxWidth|maxHeight in settings
        if (self.options.maxWidth && self.options.maxWidth < maxImageWidth) {
          maxImageWidth = self.options.maxWidth;
        }
        if (self.options.maxHeight && self.options.maxHeight < maxImageWidth) {
          maxImageHeight = self.options.maxHeight;
        }

        // Is the current image's width or height is greater than the maxImageWidth or maxImageHeight
        // option than we need to size down while maintaining the aspect ratio.
        if ((preloader.width > maxImageWidth) || (preloader.height > maxImageHeight)) {
          if ((preloader.width / maxImageWidth) > (preloader.height / maxImageHeight)) {
            imageWidth  = maxImageWidth;
            imageHeight = parseInt(preloader.height / (preloader.width / imageWidth), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          } else {
            imageHeight = maxImageHeight;
            imageWidth = parseInt(preloader.width / (preloader.height / imageHeight), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          }
        }
      }
      self.sizeContainer($image.width(), $image.height());
    };

    preloader.src          = this.album[imageNumber].link;
    this.currentImageIndex = imageNumber;
  };

  // Stretch overlay to fit the viewport
  Lightbox.prototype.sizeOverlay = function() {
    this.$overlay
      .width($(document).width())
      .height($(document).height());
  };

  // Animate the size of the lightbox to fit the image we are showing
  Lightbox.prototype.sizeContainer = function(imageWidth, imageHeight) {
    var self = this;

    var oldWidth  = this.$outerContainer.outerWidth();
    var oldHeight = this.$outerContainer.outerHeight();
    var newWidth  = imageWidth + this.containerPadding.left + this.containerPadding.right + this.imageBorderWidth.left + this.imageBorderWidth.right;
    var newHeight = imageHeight + this.containerPadding.top + this.containerPadding.bottom + this.imageBorderWidth.top + this.imageBorderWidth.bottom;

    function postResize() {
      self.$lightbox.find('.lb-dataContainer').width(newWidth);
      self.$lightbox.find('.lb-prevLink').height(newHeight);
      self.$lightbox.find('.lb-nextLink').height(newHeight);
      self.showImage();
    }

    if (oldWidth !== newWidth || oldHeight !== newHeight) {
      this.$outerContainer.animate({
        width: newWidth,
        height: newHeight
      }, this.options.resizeDuration, 'swing', function() {
        postResize();
      });
    } else {
      postResize();
    }
  };

  // Display the image and its details and begin preload neighboring images.
  Lightbox.prototype.showImage = function() {
    this.$lightbox.find('.lb-loader').stop(true).hide();
    this.$lightbox.find('.lb-image').fadeIn(this.options.imageFadeDuration);

    this.updateNav();
    this.updateDetails();
    this.preloadNeighboringImages();
    this.enableKeyboardNav();
  };

  // Display previous and next navigation if appropriate.
  Lightbox.prototype.updateNav = function() {
    // Check to see if the browser supports touch events. If so, we take the conservative approach
    // and assume that mouse hover events are not supported and always show prev/next navigation
    // arrows in image sets.
    var alwaysShowNav = false;
    try {
      document.createEvent('TouchEvent');
      alwaysShowNav = (this.options.alwaysShowNavOnTouchDevices) ? true : false;
    } catch (e) {}

    this.$lightbox.find('.lb-nav').show();

    if (this.album.length > 1) {
      if (this.options.wrapAround) {
        if (alwaysShowNav) {
          this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1');
        }
        this.$lightbox.find('.lb-prev, .lb-next').show();
      } else {
        if (this.currentImageIndex > 0) {
          this.$lightbox.find('.lb-prev').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-prev').css('opacity', '1');
          }
        }
        if (this.currentImageIndex < this.album.length - 1) {
          this.$lightbox.find('.lb-next').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-next').css('opacity', '1');
          }
        }
      }
    }
  };

  // Display caption, image number, and closing button.
  Lightbox.prototype.updateDetails = function() {
    var self = this;

    // Enable anchor clicks in the injected caption html.
    // Thanks Nate Wright for the fix. @https://github.com/NateWr
    if (typeof this.album[this.currentImageIndex].title !== 'undefined' &&
      this.album[this.currentImageIndex].title !== '') {
      var $caption = this.$lightbox.find('.lb-caption');
      if (this.options.sanitizeTitle) {
        $caption.text(this.album[this.currentImageIndex].title);
      } else {
        $caption.html(this.album[this.currentImageIndex].title);
      }
      $caption.fadeIn('fast')
        .find('a').on('click', function(event) {
          if ($(this).attr('target') !== undefined) {
            window.open($(this).attr('href'), $(this).attr('target'));
          } else {
            location.href = $(this).attr('href');
          }
        });
    }

    if (this.album.length > 1 && this.options.showImageNumberLabel) {
      var labelText = this.imageCountLabel(this.currentImageIndex + 1, this.album.length);
      this.$lightbox.find('.lb-number').text(labelText).fadeIn('fast');
    } else {
      this.$lightbox.find('.lb-number').hide();
    }

    this.$outerContainer.removeClass('animating');

    this.$lightbox.find('.lb-dataContainer').fadeIn(this.options.resizeDuration, function() {
      return self.sizeOverlay();
    });
  };

  // Preload previous and next images in set.
  Lightbox.prototype.preloadNeighboringImages = function() {
    if (this.album.length > this.currentImageIndex + 1) {
      var preloadNext = new Image();
      preloadNext.src = this.album[this.currentImageIndex + 1].link;
    }
    if (this.currentImageIndex > 0) {
      var preloadPrev = new Image();
      preloadPrev.src = this.album[this.currentImageIndex - 1].link;
    }
  };

  Lightbox.prototype.enableKeyboardNav = function() {
    $(document).on('keyup.keyboard', $.proxy(this.keyboardAction, this));
  };

  Lightbox.prototype.disableKeyboardNav = function() {
    $(document).off('.keyboard');
  };

  Lightbox.prototype.keyboardAction = function(event) {
    var KEYCODE_ESC        = 27;
    var KEYCODE_LEFTARROW  = 37;
    var KEYCODE_RIGHTARROW = 39;

    var keycode = event.keyCode;
    var key     = String.fromCharCode(keycode).toLowerCase();
    if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
      this.end();
    } else if (key === 'p' || keycode === KEYCODE_LEFTARROW) {
      if (this.currentImageIndex !== 0) {
        this.changeImage(this.currentImageIndex - 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(this.album.length - 1);
      }
    } else if (key === 'n' || keycode === KEYCODE_RIGHTARROW) {
      if (this.currentImageIndex !== this.album.length - 1) {
        this.changeImage(this.currentImageIndex + 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(0);
      }
    }
  };

  // Closing time. :-(
  Lightbox.prototype.end = function() {
    this.disableKeyboardNav();
    $(window).off('resize', this.sizeOverlay);
    this.$lightbox.fadeOut(this.options.fadeDuration);
    this.$overlay.fadeOut(this.options.fadeDuration);
    $('select, object, embed').css({
      visibility: 'visible'
    });
    if (this.options.disableScrolling) {
      $('html').removeClass('lb-disable-scrolling');
    }
  };

  return new Lightbox();
}));

$(function () {

    addLoading = function () {
        //var loading = document.createElement('div');
        //loading.id = "loading-wrapper";
        //var loader = document.createElement('div');
        //loader.className = "loading-icon";
        //loading.appendChild(loader);
        //$('body').append(loading.outerHTML);
        //$('body').addClass('loading-active');
    }

    removeLoading = function () {
        $("#loading-wrapper").remove();
        $('body').removeClass('loading-active');
    }

    fadeOutLoading = function (speed) {
        $("#loading-wrapper").fadeOut(speed);
        setTimeout(function () {
            removeLoading();
        }, speed);
    }

    mediaMapCheck = function () {
        var mediaMapCheck = document.getElementById('mediaMapCheck'),
            mediaMapStyles = window.getComputedStyle(mediaMapCheck),
            mediaMapDisplay = mediaMapStyles.getPropertyValue('display');
        return mediaMapDisplay;
    }

    // VALUATION Validation
    $('#valuation__step1__submit').click(function (e) {
        e.preventDefault();

        $('#valuation__postcode').removeClass("is-invalid");
        $('.valuation-postcode-error').fadeOut(0);
        $('.valuation-postcode-missing').fadeOut(0);

        if (validateForm("valuation__step1", false)) {
            console.log("Valuation step 1 sucessfully validated");

            // Validate postcode
            var postcodeSelected = false;
            var postcodeIsValid = false;
            var code = $('#hdnValuationPostcode').val().trim().toLowerCase();
            var codeLength = code.length;
            if (codeLength >= 6) {
                postcodeSelected = true;

                var segment1 = code.substring(0, 2);
                console.log('postcode segment1: ' + segment1);

                var allowable = $('#allowablePostcodes').val().trim().toLowerCase().split(';');
                var idx = _.findIndex(allowable, function (o) { return o == segment1; });
                console.log('postcode idx: ' + idx);
                if (idx >= 0) {
                    postcodeIsValid = true;
                }
            }
            console.log('postcode postcodeSelected: ' + postcodeSelected);
            console.log('postcode postcodeIsValid: ' + postcodeIsValid);

            if (postcodeSelected && postcodeIsValid) {

                // Remove active class and add class to next step
                var nextStep = $(this).attr('data-next-step');
                $(nextStep).addClass('active');

                // Set address in hdn field
                var addStr = '';
                if ($('#hdnValuationHouseNumber').val().length > 0) {
                    addStr += $('#hdnValuationHouseNumber').val();
                } else if ($('#hdnValuationHouseName').val().length > 0) {
                    addStr += $('#hdnValuationHouseName').val();
                }
                if (addStr.length > 0) { addStr += ' '; }
                addStr += $('#hdnValuationStreet').val();
                if (addStr.length > 0) { addStr += ', '; }
                addStr += $('#hdnValuationTownCity').val();

                $('#valuation__address').val(addStr);

                $('.progress-line.one').addClass('completed');
                $('.number.two').addClass('active');

                $('#step-one').removeClass('active');
                $('#step-two').addClass('active');

            } else {
                if (!postcodeSelected) {
                    $('.valuation-postcode-missing').fadeIn(0);
                } else if (!postcodeIsValid) {
                    $('.valuation-postcode-error').fadeIn(0);
                }
            }
            
        }
    });

    $('#valuation__postcode').change(function (e) {
        var currentValue = $(this).val();
        if (currentValue.length === 0) {
            $('#hdnValuationHouseNumber').val('');
            $('#hdnValuationHouseName').val('');
            $('#hdnValuationStreet').val('');
            $('#hdnValuationTownCity').val('');
            $('#hdnValuationPostcode').val('');
            $('#valuation__address').val('');
        }
    });

    $('#valuation__postcode').keyup(function (e) {
        var currentValue = $(this).val();
        if (currentValue.length === 0) {
            $('#hdnValuationHouseNumber').val('');
            $('#hdnValuationHouseName').val('');
            $('#hdnValuationStreet').val('');
            $('#hdnValuationTownCity').val('');
            $('#hdnValuationPostcode').val('');
            $('#valuation__address').val('');
        }
    });

    // search filter change placeholder
    $('.search-scat').change(function (e) {
        const val = $(this).val();
        const checked = $(this).prop('checked');
        let placeholder = "Where do you want to buy?";
        if (val === "sales" && checked) {
            placeholder = "Where do you want to buy?";
        } else if (val === "lettings" && checked) {
            placeholder = "Where do you want to rent?";
        } else if (val === "students" && checked) {
            placeholder = "Where do you want to rent?";
        }
        $('#psearch-locality').attr("placeholder", placeholder);
    });

    // format home h1
    if ($('.home-intro-panel').length > 0) {
        const homeh1 = $('.home-intro-panel h1');
        if (homeh1) {
            $(homeh1).html($(homeh1).html().replace("Introducing", "<span>Introducing</span>"));
        }
    }

    $('#valuation__step2__submit').click(function (e) {
        e.preventDefault();

        if (validateForm("valuation__step2", false)) {
            console.log("Valuation step 2 sucessfully validated");

            $('.form-valuation-message').remove();
            $('#valuation__step2__submit').fadeOut(0);
            $('#valuation__step2__wait').removeClass("show-none");

            // Offline or online?
            if ($("input[name='valuation__type']:checked").val() === 'Online') {
                submitOnlineValuation();                
            }
            else {
                submitOfflineValuation();
            }
        }
    });

    var submitOfflineValuation = function (e) {
        // Submit details
        var bmApiUrl = window['__appConfig'].apiUrl;
        var data = {
            Online: false,
            CurrentPostcode: $('#hdnValuationPostcode').val(),
            CurrentAddress: $('#valuation__address').val(),
            PropertyTypeId: $('#valuation__propertytype').val(),
            Bedrooms: $('#valuation__bedrooms').val(),
            Title: $('#valuation__title').val(),
            FirstName: $('#valuation__fistname').val(),
            Surname: $('#valuation__surname').val(),
            Telephone: $('#valuation__telephone').val(),
            Email: $('#valuation__email').val(),
            Information: $('#valuation_info').val(),
            NotRobot: $('#NotRobot').val()
        };
        var dataJson = JSON.stringify(data);

        $.ajax({
            url: bmApiUrl + "api/1.0/Widget/OfflineValuationEnquiry",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: dataJson,
            cache: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            statusCode: {
                400: showErrorResponse,
                404: showErrorResponse,
                401: showErrorResponse,
                200: showSuccessResponse
            }
        });

        function showSuccessResponse(resultObject) {
            if (resultObject.status == 200) {
                // Remove active class and add class to next step
                var nextStep = $(this).attr('data-next-step');
                $(nextStep).addClass('active');

                $('.progress-line.two').addClass('completed');
                $('.number.three').addClass('active');

                $('#step-two').removeClass('active');
                $('#step-three').addClass('active');

                $('#valuation__offline__result').removeClass('show-none');
                $('.valuation-address-display').html(resultObject.keyID.currentAddress);
                $('.valuation-email-display').html(resultObject.keyID.email);              
                
                // Clean up
                $('#valuation__step2__submit').fadeIn(0);
                $('.spinner').remove();
                $("html, body").animate({ scrollTop: $(".form-outer-zone").offset().top - 100 }, 1000);
            }
            else {
                console.log("An error occurred while sending your valuation enquiry");
                $('#valuation__step2__submit').fadeIn(0);
                $('#valuation__step2__wait').addClass("show-none");
                $('.spinner').remove();
            }
        }

        function showErrorResponse(resultObject) {
            console.log("An error occurred while sending your valuation enquiry");
            $('#valuation__step2__submit').fadeIn(0);
            $('#valuation__step2__wait').addClass("show-none");
            $('.spinner').remove();
        }
    }

    var submitOnlineValuation = function (e) {
        // Submit details
        var bmApiUrl = window['__appConfig'].apiUrl;
        var data = {
            Online: true,
            CurrentPostcode: $('#hdnValuationPostcode').val(),
            CurrentAddress: $('#valuation__address').val(),
            PropertyTypeId: $('#valuation__propertytype').val(),
            Bedrooms: $('#valuation__bedrooms').val(),
            Title: $('#valuation__title').val(),
            FirstName: $('#valuation__fistname').val(),
            Surname: $('#valuation__surname').val(),
            Telephone: $('#valuation__telephone').val(),
            Email: $('#valuation__email').val(),
            Information: $('#valuation_info').val(),
            NotRobot: $('#NotRobot').val()
        };
        var dataJson = JSON.stringify(data);

        $.ajax({
            url: bmApiUrl + "api/1.0/Widget/OnlineValuationEnquiry",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: dataJson,
            cache: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            statusCode: {
                400: showErrorResponse,
                404: showErrorResponse,
                401: showErrorResponse,
                200: showSuccessResponse
            }
        });

        function showSuccessResponse(resultObject) {
            if (resultObject.status == 200) {
                // Remove active class and add class to next step
                var nextStep = $(this).attr('data-next-step');
                $(nextStep).addClass('active');

                $('.progress-line.two').addClass('completed');
                $('.number.three').addClass('active');

                $('#step-two').removeClass('active');
                $('#step-three').addClass('active');

                var returnModel = resultObject.keyID;
                var wasSuccessfull = returnModel.online === true && returnModel.reportGenerated === true;
                if (wasSuccessfull) {
                    $('#valuation__online__result').removeClass('show-none');

                    // Write results for sale / letting prices
                    $('.valuation-online-sale-price-value').text(resultObject.keyID.saleDesc + " *");
                    $('.valuation-online-sale-price-value').removeClass('show-none');

                    $('.valuation-address-display').html(resultObject.keyID.currentAddress);
                    $('.valuation-email-display').html(resultObject.keyID.email);

                    $('.instant-val-disclaimer').removeClass("show-none");
                }
                else {
                    $('#valuation__online__error__result').removeClass('show-none');

                    $('.valuation-address-display').html(resultObject.keyID.currentAddress);
                    $('.valuation-email-display').html(resultObject.keyID.email);
                }

                // Clean up
                $('#valuation__step2__submit').fadeIn(0);
                $('.spinner').remove();
                $("html, body").animate({ scrollTop: $(".form-outer-zone").offset().top - 100 }, 1000);                
            }
            else {
                $('#valuation__step2__submit').fadeIn(0);
                $('#valuation__step2__wait').addClass("show-none");
                $('.spinner').remove();
            }
        }

        function showErrorResponse(resultObject) {
            console.log("An error occurred while sending your valuation enquiry");
            $('#valuation__step2__submit').fadeIn(0);
            $('#valuation__step2__wait').addClass("show-none");
            $('.spinner').remove();
        }
    }

    var resetBeatrushSaleOrRentPrice = function () {
        $('.beattherush-bedrooms').fadeIn(0);
        $('#beattherush__maxsales').children().remove();

        // 0 = sales | 1 = lettings
        if ($("input[name='beattherush_saleorletting']:checked").val() === '0') {
            $('#beattherush__maxsales').append('<option value=\"\" disabled selected>MAX PRICE £*</option>');

            $('#beattherush__maxsales').append('<option value=\"50,000\">50,000</option>');
            $('#beattherush__maxsales').append('<option value=\"100,000\">100,000</option>');
            $('#beattherush__maxsales').append('<option value=\"150,000\">150,000</option>');
            $('#beattherush__maxsales').append('<option value=\"200,000\">200,000</option>');
            $('#beattherush__maxsales').append('<option value=\"250,000\">250,000</option>');
            $('#beattherush__maxsales').append('<option value=\"300,000\">300,000</option>');
            $('#beattherush__maxsales').append('<option value=\"350,000\">350,000</option>');
            $('#beattherush__maxsales').append('<option value=\"400,000\">400,000</option>');
            $('#beattherush__maxsales').append('<option value=\"450,000\">450,000</option>');
            $('#beattherush__maxsales').append('<option value=\"500,000\">500,000</option>');
            $('#beattherush__maxsales').append('<option value=\"600,000\">600,000</option>');
            $('#beattherush__maxsales').append('<option value=\"800,000\">800,000</option>');
            $('#beattherush__maxsales').append('<option value=\"1,000,000\">1,000,000</option>');
            $('#beattherush__maxsales').append('<option value=\"2,000,000\">2,000,000</option>');
        } else {
            if ($("input[name='beattherush_occupation']:checked").val() === 'Student') {
                $('#beattherush__maxsales').append('<option value=\"\" disabled selected>MAX RENTAL £PPPW*</option>');

                $('#beattherush__maxsales').append('<option value=\"45 PPPW\">45</option>');
                $('#beattherush__maxsales').append('<option value=\"55 PPPW\">55</option>');
                $('#beattherush__maxsales').append('<option value=\"65 PPPW\">65</option>');
                $('#beattherush__maxsales').append('<option value=\"75 PPPW\">75</option>');
                $('#beattherush__maxsales').append('<option value=\"85 PPPW\">85</option>');
                $('#beattherush__maxsales').append('<option value=\"95 PPPW\">95</option>');
                $('#beattherush__maxsales').append('<option value=\"105 PPPW\">105</option>');
                $('#beattherush__maxsales').append('<option value=\"115 PPPW\">115</option>');
                $('#beattherush__maxsales').append('<option value=\"125 PPPW\">125</option>');
                $('#beattherush__maxsales').append('<option value=\"135 PPPW\">135</option>');
                $('#beattherush__maxsales').append('<option value=\"145 PPPW\">145</option>');
                $('#beattherush__maxsales').append('<option value=\"155 PPPW\">155</option>');
                $('#beattherush__maxsales').append('<option value=\"165 PPPW\">165</option>');
                $('#beattherush__maxsales').append('<option value=\"175 PPPW\">175</option>');
                $('#beattherush__maxsales').append('<option value=\"185 PPPW\">185</option>');
                $('#beattherush__maxsales').append('<option value=\"195 PPPW\">195</option>');
                $('#beattherush__maxsales').append('<option value=\"205 PPPW\">205</option>');
                $('#beattherush__maxsales').append('<option value=\"225 PPPW\">225</option>');
                $('#beattherush__maxsales').append('<option value=\"245 PPPW\">245</option>');
                $('#beattherush__maxsales').append('<option value=\"265 PPPW\">265</option>');
                $('#beattherush__maxsales').append('<option value=\"285 PPPW\">285</option>');
                $('#beattherush__maxsales').append('<option value=\"300 PPPW\">300</option>');
                $('#beattherush__maxsales').append('<option value=\"No max\">No max</option>');
            } else {
                $('#beattherush__maxsales').append('<option value=\"\" disabled selected>MAX RENTAL £PCM*</option>');

                $('#beattherush__maxsales').append('<option value=\"300 PCM\">300</option>');
                $('#beattherush__maxsales').append('<option value=\"350 PCM\">350</option>');
                $('#beattherush__maxsales').append('<option value=\"400 PCM\">400</option>');
                $('#beattherush__maxsales').append('<option value=\"450 PCM\">450</option>');
                $('#beattherush__maxsales').append('<option value=\"500 PCM\">500</option>');
                $('#beattherush__maxsales').append('<option value=\"550 PCM\">550</option>');
                $('#beattherush__maxsales').append('<option value=\"600 PCM\">600</option>');
                $('#beattherush__maxsales').append('<option value=\"650 PCM\">650</option>');
                $('#beattherush__maxsales').append('<option value=\"700 PCM\">700</option>');
                $('#beattherush__maxsales').append('<option value=\"750 PCM\">750</option>');
                $('#beattherush__maxsales').append('<option value=\"800 PCM\">800</option>');
                $('#beattherush__maxsales').append('<option value=\"850 PCM\">850</option>');
                $('#beattherush__maxsales').append('<option value=\"900 PCM\">900</option>');
                $('#beattherush__maxsales').append('<option value=\"950 PCM\">950</option>');
                $('#beattherush__maxsales').append('<option value=\"1,000 PCM\">1,000</option>');
                $('#beattherush__maxsales').append('<option value=\"1,200 PCM\">1,200</option>');
                $('#beattherush__maxsales').append('<option value=\"1,500 PCM\">1,500</option>');
                $('#beattherush__maxsales').append('<option value=\"2,000 PCM\">2,000</option>');
                $('#beattherush__maxsales').append('<option value=\"2,500 PCM\">2,500</option>');
                $('#beattherush__maxsales').append('<option value=\"3,000 PCM\">3,000</option>');
                $('#beattherush__maxsales').append('<option value=\"No max\">No max</option>');
            }
        }

        if ($("input[name='beattherush_department']:checked").val() === 'Commercial') {
            $('.beattherush-bedrooms').fadeOut(0);
        }
    }

    // Jump the queue Validation
    $('.display-beattherush-form').click(function (e) {
        e.preventDefault();
        $('#beattherush-form').removeClass("hide");
        $("html, body").animate({ scrollTop: $("#beattherush-form").offset().top - 100 }, 1000);
    });

    $('#beattherush__step1__submit').click(function (e) {
        e.preventDefault();

        if (validateForm("beattherush__step1", false)) {
            console.log("Jump the queue step 1 sucessfully validated");

            // Remove active class and add class to next step
            var nextStep = $(this).attr('data-next-step');
            $(nextStep).addClass('active');

            $('.progress-line.one').addClass('completed');
            $('.number.two').addClass('active');

            // 0 = sales | 1 = lettings
            if ($("input[name='beattherush_saleorletting']:checked").val() === '0') {
                $('#step-one').removeClass('active');
                $('#step-twob').addClass('active');
            } else {
                $('#step-one').removeClass('active');
                $('#step-two').addClass('active');
            }
            
            $("html, body").animate({ scrollTop: $("#beattherush-form").offset().top - 100 }, 1000);
        }
    });

    $('#beattherush__step2__submit').click(function (e) {
        e.preventDefault();

        if (validateForm("beattherush__step2", false)) {
            console.log("Jump the queue step 2 sucessfully validated");

            $('.progress-line.two').addClass('completed');
            $('.number.three').addClass('active');

            resetBeatrushSaleOrRentPrice();

            $('#step-two').removeClass('active');
            $('#step-three').addClass('active');

            $("html, body").animate({ scrollTop: $("#beattherush-form").offset().top - 100 }, 1000);
        }
    });
    
    $('#beattherush__step2b__submit').click(function (e) {
        e.preventDefault();

        if (validateForm("beattherush__step2b", false)) {
            console.log("Jump the queue step 2b sucessfully validated");

            $('.progress-line.two').addClass('completed');
            $('.number.three').addClass('active');
            
            resetBeatrushSaleOrRentPrice();

            $('#step-twob').removeClass('active');
            $('#step-three').addClass('active');

            $("html, body").animate({ scrollTop: $("#beattherush-form").offset().top - 100 }, 1000);
        }
    });

    $('#beattherush__step3__submit').click(function (e) {
        e.preventDefault();

        if (validateForm("beattherush__step3", false)) {
            console.log("Jump the queue step 3 sucessfully validated");

            $('.form-beattherush-message').remove();
            $('#beattherush__step3__submit').fadeOut(0);
            $('#beattherush__step3__wait').removeClass("show-none");            

            // Submit details
            var bmApiUrl = window['__appConfig'].apiUrl;
            var data = {
                SaleOrLetting: $("input[name='beattherush_saleorletting']:checked").val(),
                OccupationDesc: $("input[name='beattherush_occupation']:checked").val(),
                DepartmentDesc: $("input[name='beattherush_department']:checked").val(),
                Title: $('#beattherush__title').val(),
                FirstName: $('#beattherush__fistname').val(),
                Surname: $('#beattherush__surname').val(),
                Telephone: $('#beattherush__telephone').val(),
                Email: $('#beattherush__email').val(),
                CurrentAddress: $('#beattherush__address').val(),
                CurrentPostcode: $('#beattherush__postcode').val(),
                Locations: $('#beattherush__locations').val(),
                Radius: $('#beattherush__location__radius').val(),
                SalePrice: $('#beattherush__maxsales').val(),
                Bedrooms: $('#beattherush__bedrooms').val(),
                StartDate: $('#beattherush__startdate').val(),
                Requirements: $('#beattherush__special__requirements').val(),
                Consent: $('#beattherush__consent').prop('checked'),
                NotRobot: $('#NotRobot').val()
            };
            var dataJson = JSON.stringify(data);

            $.ajax({
                url: bmApiUrl + "api/1.0/Widget/RushingEnquiry",
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: dataJson,
                cache: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                statusCode: {
                    400: showErrorResponse,
                    404: showErrorResponse,
                    401: showErrorResponse,
                    200: showSuccessResponse
                }
            });

            function showSuccessResponse(resultObject) {
                if (resultObject.status == 200) {                    
                    // Remove active class and add class to next step
                    $('#step-three').removeClass('active');
                    $('#step-four').addClass('active');

                    // Clean up
                    $('#beattherush__step3__submit').fadeIn(0);
                    $('#beattherush__step3__wait').addClass("show-none");
                    $('.spinner').remove();
                    $("html, body").animate({ scrollTop: $("#beattherush-form").offset().top - 100 }, 1000);
                }
                else {
                    // $("<div class=\"validate__error__row\">" + resultObject.message + "</div>").insertAfter('#beattherush__fistname');
                    $('#beattherush__step3__submit').fadeIn(0);
                    $('#beattherush__step3__wait').addClass("show-none");
                    $('.spinner').remove();
                }
            }

            function showErrorResponse(resultObject) {
                console.log("An error occurred while sending your jump the queue enquiry");
                $('#beattherush__step3__submit').fadeIn(0);
                $('#beattherush__step3__wait').addClass("show-none");
                $('.spinner').remove();
            }
        }
    });

    //CAPTURE FORM
    $('.capture__form__submit').on('click', function (e) {
        e.preventDefault();
        $('.form-capture-message').remove();
        $('.capture__form__submit').fadeOut(0);
        $('.capture__form__wait').removeClass("show-none");

        if (validateForm("capture", false)) {
            console.log("capture form sucessfully validated");

            var bmApiUrl = window['__appConfig'].apiUrl;
            var data = {
                FullName: $('#capture_name').val(),
                Email: $('#capture_email').val(),
                Telephone: $('#capture_telephone').val(),
                PageTitle: $('#capture_pagetitle').val()
            };
            var dataJson = JSON.stringify(data);

            $.ajax({
                url: bmApiUrl + "api/1.0/Form/FeatureCapture",
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: dataJson,
                cache: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                statusCode: {
                    400: showErrorResponse,
                    404: showErrorResponse,
                    401: showErrorResponse,
                    200: showSuccessResponse
                }
            });

            function showSuccessResponse(resultObject) {
                if (resultObject.status == 200) {
                    $("#capture__form__wrapper").fadeOut(500);
                    $("#capture__form__success").fadeIn(1000);
                }
                else {
                    $("<div class=\"bd-callout bd-callout-danger form-capture-message\"><p>" + resultObject.message + "</p></div>").insertBefore('#capture__form');
                    $('.capture__form__submit').fadeIn(0);
                    $('.capture__form__wait').addClass("show-none");
                    $('.spinner').remove();
                }
            }

            function showErrorResponse(resultObject) {
                console.log("An error occurred while sending your enquiry");
                $("<div class=\"bd-callout bd-callout-danger form-capture-message\"><p>" + resultObject.message + "</p></div>").insertBefore('#capture__form');
                $('.capture__form__submit').fadeIn(0);
                $('.capture__form__wait').addClass("show-none");
                $('.spinner').remove();
            }
        }
        else {
            $('.capture__form__submit').fadeIn(0);
            $('.capture__form__wait').addClass("show-none");
            $('.spinner').remove();
        }
    });

    // Property Contact Form
    $('.property__contact__form__submit').on('click', function (e) {
        e.preventDefault();
        $('.form-contact-message').remove();
        $('.property__contact__form__submit').fadeOut(0);
        $('.property__contact__form__wait').removeClass("show-none");

        if (validateForm("property-contact", false)) {
            console.log("Property contact form sucessfully validated");

            var bmApiUrl = window['__appConfig'].apiUrl;
            var contactMessage = $('#contact_message').val();
            var currentPageUrl = "Property page url: " + window.location.href;
            contactMessage = contactMessage + "\r\n\r\n" + currentPageUrl;

            var data = {
                FullName: $('#contact_name').val(),
                Email: $('#contact_email').val(),
                Telephone: $('#contact_telephone').val(),
                Message: contactMessage,
                MarketingOptIn: $('#contact_marketing_optin').prop('checked'),
                NotRobot: $('#NotRobot').val()
            };
            var dataJson = JSON.stringify(data);

            $.ajax({
                url: bmApiUrl + "api/1.0/Form/PropertyContactEnquiry",
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: dataJson,
                cache: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                statusCode: {
                    400: showErrorResponse,
                    404: showErrorResponse,
                    401: showErrorResponse,
                    200: showSuccessResponse
                }
            });

            function showSuccessResponse(resultObject) {
                if (resultObject.status == 200) {
                    $('.property__contact__form__wait').text("Message received. Thank you!");
                }
                else {
                    $('.property__contact__form__submit').fadeIn(0);
                    $('.property__contact__form__wait').addClass("show-none");
                    $('.spinner').remove();
                }
            }

            function showErrorResponse(resultObject) {
                console.log("An error occurred while sending your enquiry");
                $('.property__contact__form__submit').fadeIn(0);
                $('.property__contact__form__wait').addClass("show-none");
                $('.spinner').remove();
            }
        }
        else {
            $('.property__contact__form__submit').fadeIn(0);
            $('.property__contact__form__wait').addClass("show-none");
            $('.spinner').remove();
        }
    });

    //CONTACT FORM
    $('.contact__form__submit').on('click', function (e) {
        e.preventDefault();
        $('.form-contact-message').remove();
        $('.contact__form__submit').fadeOut(0);
        $('.contact__form__wait').removeClass("show-none");

        if (validateForm("contact", false)) {
            console.log("Contact form sucessfully validated");

            var bmApiUrl = window['__appConfig'].apiUrl;
            var data = {
                FullName: $('#contact_name').val(),
                Email: $('#contact_email').val(),
                Telephone: $('#contact_telephone').val(),
                Subject: $('#contact_subject').val(),
                Message: $('#contact_message').val(),
                NotRobot: $('#NotRobot').val()
            };
            var dataJson = JSON.stringify(data);

            $.ajax({
                url: bmApiUrl + "api/1.0/Form/ContactEnquiry",
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: dataJson,
                cache: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                statusCode: {
                    400: showErrorResponse,
                    404: showErrorResponse,
                    401: showErrorResponse,
                    200: showSuccessResponse
                }
            });

            function showSuccessResponse(resultObject) {
                if (resultObject.status == 200) {
                    $("#contact__form__wrapper").fadeOut(2000);
                    document.location.href = "/contact/contact-confirmation/";
                }
                else {
                    $("<div class=\"bd-callout bd-callout-danger form-contact-message\"><p>" + resultObject.message + "</p></div>").insertBefore('#contact__form');
                    $('.contact__form__submit').fadeIn(0);
                    $('.contact__form__wait').addClass("show-none");
                    $('.spinner').remove();
                }
            }

            function showErrorResponse(resultObject) {
                console.log("An error occurred while sending your contact enquiry");
                $("<div class=\"bd-callout bd-callout-danger form-contact-message\"><p>" + resultObject.message + "</p></div>").insertBefore('#contact__form');
                $('.contact__form__submit').fadeIn(0);
                $('.contact__form__wait').addClass("show-none");
                $('.spinner').remove();
            }
        }
        else {
            $('.contact__form__submit').fadeIn(0);
            $('.contact__form__wait').addClass("show-none");
            $('.spinner').remove();
        }
    });

    //NEWSLETTER FORM
    $('.newsletter__form__submit').on('click', function (e) {
        e.preventDefault();
        $('.form-news-message').remove();
        // $('.newsletter__form__submit').fadeOut(0);
        // $("<div class=\"spinner small newletter\"></div>").insertAfter('.newsletter__form__submit');
        $('#newsletter__form__submit').prop('disabled', true);

        if (validateForm("newsletter", false)) {
            console.log("Newsletter form sucessfully validated");

            var bmApiUrl = window['__appConfig'].apiUrl;
            var data = { Email: $('#newsletter__email').val(), FullName: $('#newsletter__name').val() };
            var dataJson = JSON.stringify(data);

            $.ajax({
                url: bmApiUrl + "api/1.0/Newsletter/Signup",
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: dataJson,
                cache: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                statusCode: {
                    400: showErrorResponse,
                    404: showErrorResponse,
                    401: showErrorResponse,
                    200: showSuccessResponse
                }
            });

            function showSuccessResponse(resultObject) {
                if (resultObject.status == 200) {
                    $('#newsletter__email').val("");
                    $('#newsletter__name').val("");
                    $("html, body").animate({ scrollTop: $("#newsletter__form").offset().top - 100 }, 1000); 
                    $('.form-news-intro').text("You have successfully been added to our mailing list. Thank You.");
                    $(".signup-form-group").css("display", "none");
                    // $('#newsletter__form').parent().css("height", "250px");
                }
                else if (resultObject.status == 403) {
                    $("<div class=\"validate__error__row\">" + resultObject.message + "</div>").insertAfter('#newsletter__email');
                    // $('.newsletter__form__submit').fadeIn(0);
                    // $('.spinner').remove();
                    $('#newsletter__form__submit').prop('disabled', false);
                }
                else {
                    $("<div class=\"validate__error__row\">" + resultObject.message + "</div>").insertAfter('#newsletter__name');
                    // $('.newsletter__form__submit').fadeIn(0);
                    // $('.spinner').remove();
                    $('#newsletter__form__submit').prop('disabled', false);
                }
            }

            function showErrorResponse(resultObject) {
                console.log("An error occurred while adding this record to the newsletter list");
                // $('.newsletter__form__submit').fadeIn(0);
                // $('.spinner').remove();
                $('#newsletter__form__submit').prop('disabled', false);
            }
        }
        else {
            // $('.newsletter__form__submit').fadeIn(0);
            // $('.spinner').remove();
            $('#newsletter__form__submit').prop('disabled', false);
        }
    });

    // PAYMENT FORM
    $('.payment__form__submit').on('click', function (e) {
        e.preventDefault();
        $('.form-payment-message').remove();
        $('.payment__form__submit').fadeOut(0);
        $("<div class=\"spinner small payment\"></div>").insertAfter('.payment__form__submit');

        if (validateForm("payment", false)) {
            console.log("Payment form sucessfully validated");
            $("#payment__form").submit();
        } else {
            $('.payment__form__submit').fadeIn(0);
            $('.spinner').remove();
        }
    });

    $('#BillingAddressSame').on('click', function (e) {
        if ($(this).prop('checked')) {
            // Hide rows and populate form fields
            $('.dyn-billing-info').addClass('row-shown-none');
            $('#BillingAddress1').val($('#Address1').val());
            $('#BillingAddress2').val($('#Address2').val());
            $('#BillingAddressTown').val($('#AddressTown').val());
            $('#BillingAddressPostcode').val($('#AddressPostcode').val());
        } else {
            // Display rows and clean data
            $('.dyn-billing-info').removeClass('row-shown-none');
            $('#BillingAddress1').val('');
            $('#BillingAddress2').val('');
            $('#BillingAddressTown').val('');
            $('#BillingAddressPostcode').val('');
        }
    });

    //FORM VALIDATION
    validateForm = function (formType, addWarningMessage, callback) {
        var valItems = $('[data-formtype="' + formType + '"] [data-required="true"]'), formValid = true;
        console.log("valItems.length " + valItems.length);

        // Clear validation
        $('.validate__error__row').remove();
        for (var i = 0, valItem; valItem = valItems[i++];) {
            valItem.classList.remove("is-invalid");
        }
        $('label[class="is-invalid"]').each(function (index, item) {
            $(item).removeClass("is-invalid");
        });

        // Add validation
        function insertValidation(el, msg) {
            var er = document.createElement('span');
            er.className = "validate__error__row";
            er.innerHTML = msg;
            $(er.outerHTML).insertAfter(el);
            // setTimeout(function () { $(".validate__error__row").remove(); }, 10000);
        }

        // Perform validation
        for (var i = 0, valItem; valItem = valItems[i++];) {
            var node = valItem.nodeName,
                valid = true,
                msg;
            if (node === "INPUT") {
                if (valItem.getAttribute('type') != "email") {
                    if (valItem.getAttribute('type') == "text" || valItem.getAttribute('type') == "number") {
                        valid = valItem.value.length < 1 ? false : valid;
                        msg = "Please enter a value";
                    } else if (valItem.getAttribute('type') == "file") {
                        valid = valItem.value.length < 1 ? false : valid;
                        msg = "Please select a file";
                    } else if (valItem.getAttribute('type') == "tel") {
                        valid = valItem.value.length < 1 ? false : valid;
                        msg = "Please select a value";
                    } else if (valItem.getAttribute('type') == "password") {
                        valid = valItem.value.length < 1 ? false : valid;
                        msg = "Please select a value";
                    } else if (valItem.getAttribute('type') == "checkbox") {
                        valid = !valItem.checked ? false : valid;
                        msg = "You must select this option";
                    }
                } else {
                    valid = valItem.value.length < 1 ? false : valid;
                    msg = "Please enter a value";
                    if (valid) {
                        var emReg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        valid = !emReg.test(valItem.value) ? false : valid;
                        msg = "Please enter a valid email";
                    }
                }
            } else if (node === "SELECT") {
                valid = valItem.value == '' ? false : valid;
                msg = "Please select a option";
            } else if (node === "TEXTAREA") {
                valid = valItem.value.length < 1 ? false : valid;
                msg = "Please enter a value";
            }
            if (!valid) {
                valItem.classList.add("is-invalid");
                if (valItem.getAttribute('type') == "checkbox") {
                    $(valItem).closest("label").addClass("is-invalid");
                }                
                if (addWarningMessage) {
                    insertValidation(valItem, msg);
                }                
                formValid = false;
            }
        }
        return formValid;
    }

    $('#PaymentAmount').keypress(function (e) {
        return numberDecimalEntry('PaymentAmount', 8, e);
    });

    $('#PaymentAmount').blur(function (e) {
        formatMoneyNumber('PaymentAmount');
    });

    $(".scroll").click(function (e) {
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });    

    /*$('.nav-link-item').click(function (e) {
        if (mediaMapCheck() === 'none') {
            var children = parseInt($(this).attr("data-children"));
            if (children > 0) {
                e.preventDefault();
            }
        }
    });*/

    formatMoneyNumber = function (field_id) {
        var field = document.getElementById(field_id);
        var j = field.value.replace(",", "");
        var i = parseFloat(j);
        if (isNaN(i)) { i = 0.00; }
        var minus = '';
        if (i < 0) { minus = '-'; }
        i = Math.abs(i);
        i = parseInt((i + .005) * 100);
        i = i / 100;
        s = new String(i);
        if (s.indexOf('.') < 0) { s += '.00'; }
        if (s.indexOf('.') == (s.length - 2)) { s += '0'; }
        s = minus + s;
        if (parseInt(s) == 0) {
            field.value = '0.00';
        }
        else {
            field.value = s;
        }
    }

    numberDecimalEntry = function (field_id, max_length, raised_event) {
        var field = document.getElementById(field_id);
        var keynum;
        var strEntry = field.value;
        var currlen = strEntry.length;

        if (strEntry.indexOf('.') < 0) {
            currlen = currlen + 3;
        }

        if (window.event) // IE
        {
            keynum = raised_event.keyCode; // Get the number of the key pressed

            if (currlen > max_length)	// Make sure it's not too long
            {
                if (keynum == 8 || keynum == 127) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                if (keynum == 8 || keynum == 127) {
                    return true;
                }
                else if (keynum == 46) {
                    return true;
                }
                else {
                    if (keynum > 47 && keynum < 58) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        }
        else if (raised_event.which) // Netscape/Firefox/Opera
        {
            keynum = raised_event.which; 	// Get the number of the key pressed

            if (currlen > max_length)	// Make sure it's not too long
            {
                if (keynum == 8 || keynum == 127) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                if (keynum == 8 || keynum == 127) {
                    return true;
                }
                else if (keynum == 46) {
                    return true;
                }
                else {
                    if (keynum > 47 && keynum < 58) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        }
        else {	// Return true if the event properties aren't set for the different browsers
            return true;
        }
    }

    heightCheck = function (elem) {
        var maxOuterHeight = 0;
        $(elem).css('height', 'auto');
        if ($(window).width() > 767) {
            $(elem).each(function () {
                if ($(this).outerHeight() > maxOuterHeight) { maxOuterHeight = $(this).outerHeight(); }
            });
            $(elem).outerHeight(maxOuterHeight);
        }
    }

    heightCheck('.news-content');
    // heightCheck('.service-items-slider-item__text');
    heightCheck('.team-member-content');
    $(window).resize(function () {
        heightCheck('.news-content');
        // heightCheck('.service-items-slider-item__text');
        heightCheck('.team-member-content');
    });

    setTimeout(function () {
        fadeOutLoading(100);
    }, 50);

    if ($('#beattherush__startdate').length > 0) {
        $('#beattherush__startdate').datepicker({ format: 'dd/mm/yyyy' });
    }

    $('#home-content-intro-scroll').click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: $("#home-content-intro").offset().top - 25 }, 1000);
    });

    $('#about-content-intro-scroll').click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: $("#div-team-member-listing").offset().top - 100 }, 1000);
    });

    if ($('#guide__accordion').length > 0) {
        var acc = document.getElementsByClassName("accordion-heading");
        var i;
        for (i = 0; i < acc.length; i++)
        {
            acc[i].addEventListener("click", function() {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                var closestIcon = this.querySelector(".fas");
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                    closestIcon.classList.remove("fa-chevron-down");
                    closestIcon.classList.add("fa-chevron-right");
                } else {
                    panel.style.display = "block";
                    closestIcon.classList.remove("fa-chevron-right");
                    closestIcon.classList.add("fa-chevron-down");
                }
            });
        }
    }

    $('.team-member-open').on('click', function (e) {
        e.preventDefault();
        var itemid = $(this).attr("data-item-id");
        var offsetTopBase = $('.team-member-listing').offset().top;
        var offsetTopItem = $(this).offset().top;
        var offsetTopx = offsetTopItem - offsetTopBase - 175;
        if ($(window).width() <= 1024) {
            offsetTopx = 0;
            $('body').toggleClass("noscroll-fixed");
        }
        $('.team-member-detail').fadeOut(0);
        $('.team-member-detail[data-item-id='+ itemid +']').css({ top: offsetTopx + 'px' });
        $('.team-member-detail[data-item-id='+ itemid +']').fadeIn(200);
        // $("html, body").animate({ scrollTop: $('.team-member-detail[data-item-id='+ itemid +']').offset().top - 100 }, 0);
    });

    $('.team-member-close').on('click', function (e) {
        e.preventDefault();
        var itemid = $(this).attr("data-item-id");
        $('.team-member-detail[data-item-id='+ itemid +']').fadeOut(0);
        $('.team-member-detail[data-item-id='+ itemid +']').css({ top: '0px' });
        $('body').removeClass("noscroll-fixed");
        // $("html, body").animate({ scrollTop: $('.team-member-item[data-item-id='+ itemid +']').offset().top - 100 }, 0); 
    });

    // Property listing on click event
    $(document).on('click', '.featured-property-wrapper', function (e) {
        e.preventDefault();
        if ($(this).attr("data-url") !== undefined && $(this).attr("data-url").length > 0) {
            document.location.href = $(this).attr("data-url");
        }
    });

});

$('.btn-header-link').on('click', function (e) {
    e.preventDefault();
});

//NEWSLETTER FORM
$('.student_landing__form__submit').on('click', function (e) {
    console.log('start landing function');
    e.preventDefault();
    
    $('.form-news-message').remove();
    //$('.student_landing__form__submit').fadeOut(0);
    //$("<div class=\"spinner small newletter\"></div>").insertAfter('.student_landing__form__submit');

    if (validateForm("student_landing", true)) {
        console.log("Student form sucessfully validated");

        $('#student-landing-form').submit(function (e) {
            console.log('inside send');
            var $this = $(this);
            $.ajax({
                type: "GET", // GET & url for json slightly different
                url: "https://elastic-jelly.us20.list-manage.com/subscribe/post-json?c=?",
                data: $this.serialize(),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                error: function (err) { alert("Could not connect to the registration server."); },
                success: function (data) {
                    if (data.result != "success") {
                        console.log('error');
                    } else {
                        console.log('success mail');
                    }
                }
            });
            return false;
        });

        function showSuccessResponse(resultObject) {
            if (resultObject.status == 200) {

                $('#student_landing__email').val("");
                $('#student_landing__name').val("");
                $('#student_landing__telephone').val("");
                $("html, body").animate({ scrollTop: $("#student__form").offset().top - 100 }, 1000);
                $('.form-news-intro').text("You are now registered. Thank You.");
                //$(".form-news-group").css("display", "none");

            }
            else if (resultObject.status == 403) {
                $("<div class=\"validate__error__row\">" + resultObject.message + "</div>").insertAfter('#student_landing__email');

            }
            else {
                $("<div class=\"validate__error__row\">" + resultObject.message + "</div>").insertAfter('#student_landing__name');
 
            }
        }

        function showErrorResponse(resultObject) {
            console.log("An error occurred while adding this record to the newsletter list");
        }
    }
    else {
      
    }
});
$(function () {

    // Navigation state "flag"
    var isFixed = false;
    var scrollamount = 0;
    $(".property-fixed").hide();

    if ($(window).scrollTop() > 50) {
        $('.navigation-bg').addClass('scrolled');
    } else {
        $('.navigation-bg').removeClass('scrolled');
    }

    $(document).on("scroll", function () {
        var mainnavigation = $("#main-navigation");
        var navigationbg = $(".navigation-bg");
        var mainnavigationheight = $("#main-navigation").height();
        var gallerywrapper = $(".gallery-wrapper").height();
        var fullwidthblueheight = $(".full-width-blue").height();
        var fullwidthblue = $(".full-width-blue");
        var propertyfixed = $(".property-fixed");
        var propertyfixedheight = $(".property-fixed").height();

        if ($(window).scrollTop() >= (gallerywrapper + 5) && !isFixed) {
            // Add transitions if you would like
        }

        // Set fixed
        if ($(window).width() > 1199) {
            if ($(window).scrollTop() >= (gallerywrapper + fullwidthblueheight)) {
                isFixed = true;
                mainnavigation.hide();
                $(".full-width-blue").hide();
                $(".property-information").hide();
                $(".property-fixed").show();
                $(".body-content").css({ "margin-top": "220px" });
                $(".sidebar").css({ "margin-top": ("220px") });
            }

            // Set static
            if ($(window).scrollTop() < (gallerywrapper + fullwidthblueheight) && isFixed) {
                mainnavigation.show();
                mainnavigation.css({ "margin-top": (0 + "px") });
                $(".property-fixed").hide();
                $(".property-information").show();
                $(".full-width-blue").show();
                fullwidthblue.removeClass("fixed-navbar");
                $(".body-content").css({ "margin-top": "0" });
                $(".sidebar").css({ "margin-top": "0" });
            }
        }

        // Scroll check for jump top button
        if ($(window).scrollTop() > 300) {
            $('.jump-to-top-float').css('display', 'block');
        } else {
            $('.jump-to-top-float').css('display', 'none');
        }
    });

    $(window).resize(function () {
        var headerHeight = $(".navigation-bg").height();
        // Full width blue property page same size as property info
        $(".breadcrumbs-wrapper-main").css({ "top": (headerHeight) });
    });

    // Contact details mobile only display
    $(".show-contact-details").click(function () {
        var contactinfoheight = $(".property-information").height();
        $(".full-width-blue").addClass("contact-details");
        $(".full-width-blue").removeClass("property-details")
        var fullwidthblueheight = $(".full-width-blue").height();;
        $(".property-information").css({ "height": fullwidthblueheight });
        $(".details").css({ "display": "none" });
        $(".contact-details").css({ "display": "block" });
        $(".switchbutton").removeClass("active");
        $(this).addClass("active");

        if ($(window).width() < 767) {
            $(".contact-details").css({ "padding-top": "10px" });
        }

    });

    // Property details mobile only display
    $(".show-property-details").click(function () {
        $(".details").css({ "display": "block" });
        $(".full-width-blue").addClass("property-details");
        $(".full-width-blue").removeClass("contact-details");
        $(".contact-details").css({ "display": "none" });
        $(".switchbutton").removeClass("active");
        $(this).addClass("active");
        $(".contact-details").css({ "padding-top": "0px" });
    });

    $('.switchbutton a').on('click', function (e) {
        e.preventDefault();
    });

    /* Navigation Burger Menu */
    $(".navigation-trigger").click(function () {
        $('.main-navigation-wrapper').toggleClass('active');
        $('body').toggleClass("fixed");
        $('.fixedCheck').toggleClass("fixed");

        //Hide any open menus from click
        hideMenus();
        hideBreadcrumbs();
        $('.hover-menu').css({ 'display': 'none' });
    });

    $(".main-navigation-close").click(function () {
        $('.main-navigation-wrapper').removeClass('active');
        $('body').removeClass("fixed");
        $('.fixedCheck').removeClass("fixed");
    });

    $(".main-navigation-children-toggle").click(function () {
        $(this).parent().toggleClass("active");
    });

    $(".close-info-modal").click(function () {
        $('.welcome-lightbox').css({ 'display': 'none' });
    });

    $('.nav-link .search').on('click', function (e) {
        e.preventDefault();
        console.log('.nav-link .search run');
        var dropdown = $(this).siblings('.search-wrapper');
        $(dropdown).toggleClass('active');
    });

    $('.navigation .nav-link').hover(function (e) {
        var childCount = parseInt(e.currentTarget.getAttribute('data-children').toString());
        if (childCount === 0) {
            return false;
        }
        if ($(window).width() > 1200) {
            if ($(this).hasClass('contact')) {
                return false;
            } else {
                console.log(this);
                $('.main-content').toggleClass('menu-active');
                console.log('has child hover-menu-bg');
            }
        }
    });

    $('.fullscreen, .gallery-wrapper img').on('click', function (e) {
        e.preventDefault();

        $('html,body').animate({
            scrollTop: 0
        }, 1000);

        $('.gallery-wrapper').addClass('lightbox');
    });
    $('.gallery-wrapper .modal-exit').on('click', function (e) {
        console.log('modal-exit clicked');
        e.preventDefault();
        $(this).parents().removeClass('lightbox');
    });

    /* Click nav-links for mobile */
    $(".why-bricks-mortar a").click(function (e) {
        if ($(window).width() < 1200) {
            //e.preventDefault();
            hideMenus();
            $(".hover-menu").css({ "display": "block" });
            $(".why-bricks-mortar-menu").css({ "display": "block" });

            //Breadcumb
            hideBreadcrumbs();
            $('.breadcrumb.why-bricks-mortar').addClass('active');
        }
    });
    $(".find-a-property a").click(function (e) {
        if ($(window).width() < 1200) {
            //e.preventDefault();
            hideMenus();
            $(".hover-menu").css({ "display": "block" });
            $(".find-a-property-menu").css({ "display": "block" });

            //Breadcumb
            hideBreadcrumbs();
            $('.breadcrumb.find-a-property').addClass('active');
        }
    });
    $(".market-your-property a").click(function (e) {
        if ($(window).width() < 1200) {
            //e.preventDefault();
            hideMenus();
            $(".hover-menu").css({ "display": "block" });
            $(".market-your-property-menu").css({ "display": "block" });

            //Breadcumb
            hideBreadcrumbs();
            $('.breadcrumb.market-your-property').addClass('active');
        }
    });
    $(".find-a-service a").click(function (e) {
        if ($(window).width() < 1200) {
            //e.preventDefault();
            hideMenus();
            $(".hover-menu").css({ "display": "block" });
            $(".find-a-service-menu").css({ "display": "block" });

            //Breadcumb
            hideBreadcrumbs();
            $('.breadcrumb.find-a-service').addClass('active');
        }
    });

    $('.breadcrumb-nav-link').click(function (e) {
        e.preventDefault();
    });

    // Hover menus display block

    $('.breadcrumb.menu').on('click', function () {
        hideBreadcrumbs();
        hideMenus();
        $(".hover-menu").css({ "display": "none" });
    });

    function hideBreadcrumbs() {
        //remove all breadcrumbs
        $(".breadcrumb.why-bricks-mortar").removeClass('active');
        $(".breadcrumb.find-a-property").removeClass('active');
        $(".breadcrumb.market-your-property").removeClass('active');
        $(".breadcrumb.find-a-service").removeClass('active');
    }

    function hideMenus() {
        // Hide these menus
        $(".why-bricks-mortar-menu").css({ "display": "none" });
        $(".find-a-property-menu").css({ "display": "none" });
        $(".market-your-property-menu").css({ "display": "none" });
        $(".find-a-service-menu").css({ "display": "none" });
    }

    // Select buttons

    // Navigation state "flag"
    var isFixed = false;

    $(document).on("scroll", function () {
        var navbar = $(".static-navbar");
        var heroSectionHeight = $(".fullscreen").height();

        // Set fixed
        if ($(window).scrollTop() >= heroSectionHeight && !isFixed) {
            isFixed = true;
            navbar.hide().addClass("fixed-navbar").slideDown(600);
        }

        // Set static
        if ($(window).scrollTop() < heroSectionHeight && isFixed) {
            isFixed = false;
            navbar.slideUp(600, function () {
                navbar.removeClass("fixed-navbar").show();
            });
        }
    });

    // Search results page filter wrapper
    var filterWrapperHeight = $('#psearch-fx').height();
    var mapOffset = 0;

    function fixedNaivgation(scrolledActionType) {
        // console.log('scrolledActionType: ' + scrolledActionType);

        if ($(window).scrollTop() > 50) {
            $('.navigation-bg').addClass('scrolled');
        } else {
            $('.navigation-bg').removeClass('scrolled');
        }

        // Check if on listings page
        if (filterWrapperHeight !== undefined) {
            // If y scroll is greater than the filter wrapper height
            if ($(window).scrollTop() >= mapOffset) {
                // If wrapper does NOT have class fixed
                if (!$('#psearch-fx').hasClass('psearch-fixed')) {
                    // Show wrapper and hide navigation
                    $('#psearch-fx').addClass('psearch-fixed');

                    var navBgHeight = $(".navigation-bg").height();
                    var searchHeight = $("#psearch-fx").height();
                    var totalHeightCorrx = navBgHeight + searchHeight;
                    $("body").css("padding-top", totalHeightCorrx);
                    $("#psearch-fx").css("top", navBgHeight);
                }

            } else {
                if ($('#psearch-fx').hasClass('psearch-fixed')) {
                    // Hide the fixed wrapper and show the main navigation
                    $('#psearch-fx').removeClass('psearch-fixed');
                    $("body").css("padding-top", 0);
                    $('.navigation-bg').removeClass('hide');
                }
            }

            if (scrolledActionType === 1) { // down down down
                $('#psearch-fx').fadeOut(400);
            } else if (scrolledActionType === 2) { // back up
                $('#psearch-fx').fadeIn(200);
            }
        }
    }

    var scrollPosition = $(window).scrollTop();
    var scrolledDownByXSinceLastUp = 0;

    $(window).scroll(function () {
        var scrolledActionType = 0;
        var scroll = $(window).scrollTop();
        if (scroll > scrollPosition) {
            scrolledDownByXSinceLastUp = scrolledDownByXSinceLastUp + (scroll - scrollPosition);
            // console.log("scrolledDownByXSinceLastUp: " + scrolledDownByXSinceLastUp);
            if (scrolledDownByXSinceLastUp > 300) {
                scrolledActionType = 1;
            }
        } else {
            scrolledDownByXSinceLastUp = 0;
            scrolledActionType = 2;
        }
        scrollPosition = scroll;
        fixedNaivgation(scrolledActionType);
    });

    $(window).resize(function () {
        if (filterWrapperHeight !== undefined) {
            $("#psearch-fx").removeClass("mobile-filters-active");
            $('#psearch-fx').removeClass('psearch-fixed');
            $("body").css("padding-top", "");
            $("html, body").removeClass("no-scroll");
            $("#psearch-fx").css("top", "");
            fixedNaivgation(2);
        }
    });

    // Check if arrange viewing is on footer
    $(document).on("scroll", function () {
        var enquireButton = $(".enquire-now-fixed");
        var footerTop = $("footer").offset().top;

        // Set hide
        if ($(window).scrollTop() >= footerTop) {
            enquireButton.addClass('slideOut');
        }

        // Set show
        if ($(window).scrollTop() < footerTop) {
            enquireButton.removeClass('slideOut');
        }
    });

    $("#filters-close").on('click', function (e) {
        e.preventDefault();

        $("#psearch-fx").removeClass("mobile-filters-active");
        
        $('.psearch-zone').fadeOut(0);
        $('.psearch-container').removeClass("active-zone");
        $('.search-options').removeClass('active-filter');

        $("html, body").removeClass("no-scroll");
    });

    //Share modal for property listing page
    $('.share').on('click', function (e) {
        e.preventDefault();

        $('.share-modal').addClass('active');
        $('body').addClass('lock-scroll');
    });

    $('.exit-share-modal').on('click', function () {
        $(this).parents('.share-modal').removeClass('active');
        $('body').removeClass('lock-scroll');
    });

    // Copy text
    $('.url-wrapper input').keypress(function (e) {
        e.preventDefault();
    });

    $('.copy-text').on('click', function (e) {
        e.preventDefault();
        var propertyUrlInput = document.getElementById("shared-property-text");
        propertyUrlInput.select();
        document.execCommand("copy");
    });

    $('.jump-queue-intro .show-form').on('click', function (e) {
        e.preventDefault();

        var form = $('#beattherush-form');

        $(form).removeClass('hide');
        $(form).addClass('reveal');
        $('.jump-queue-intro').addClass('hide');

        $('html, body').animate({
            scrollTop: $('.main-content h2').offset().top - 120
        }, 'slow');
    });

    // Application form
    $(document).on('click', '.section-top .expand', function (e) {
        console.log('expand section');
        e.preventDefault();

        var parentEl = $(this).closest('.section'),
            activeParent = $('.section.active');
        requiredField = $('.required', activeParent),
            empty = true;

        if (!requiredField.length == 0) {
            $(requiredField).each(function (i) {

                if ($(this).val() != "") {
                    empty = false;
                    console.log('ready to go');
                }

                if (empty) {
                    $(this).addClass('error');
                } else {
                    $(this).removeClass('error');
                    $('.section').removeClass('active');
                    $(parentEl).addClass('active');
                }
            });
        } else {
            console.log('ready to go');

            $(requiredField).removeClass('error');
            $(requiredField).attr('placeholder', '');
            $('.section').removeClass('active');
            $(parentEl).addClass('active');
        }
    });

    $('.address-to-map').on('click', function (e) {
        e.preventDefault();

        $('html,body').animate({
            scrollTop: $('#mapWrap').offset().top
        }, 500);
    });

});
$(function () {

    setFlickityForPropertyGallery = function () {
        //$('.dyn-property-images').slick({
        //    infinite: false,
        //    slidesToShow: 1,
        //    nextArrow: '<div class="next-arrow-img"></div>',
        //    prevArrow: '<div class="prev-arrow-img"></div>',
        //    dots: true
        //});

        $('.carousel-hero-wrapper .next-arrow-img').click(function (e) {
            e.preventDefault();
            const wrapper = $(this).parent();
            const imageContainer = $(wrapper).find('.carousel-hero');
            let image = $(wrapper).find('.carousel-cell').first();
            $(image).remove();
            $(image).appendTo(imageContainer);
        });

        $('.carousel-hero-wrapper .prev-arrow-img').click(function (e) {
            e.preventDefault();
            const wrapper = $(this).parent();
            const imageContainer = $(wrapper).find('.carousel-hero');
            let image = $(wrapper).find('.carousel-cell').last();
            $(image).remove();
            $(image).prependTo(imageContainer);
        });
    };

    setFlickityForPropertyFloorPlan = function () {
        $('.dyn-property-floorplan').slick({
            infinite: false,
            slidesToShow: 1,
            nextArrow: '<div class="next-arrow"></div>',
            prevArrow: '<div class="prev-arrow"></div>'
        });

        $('.dyn-property-floorplan').slick("refresh");

        var evt = window.document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
    };

    setFlickityForPropertySearch = function () {
        // to do, turn back on
        //$('.dyn-property-list-images').slick({
        //    infinite: false,
        //    slidesToShow: 1,
        //    arrows: true,
        //    nextArrow: '<div class="next-arrow-img"></div>',
        //    prevArrow: '<div class="prev-arrow-img"></div>',
        //    adaptiveHeight: true  
        //});
    };

    setFlickityForFeaturedProperties = function () {
        var $carousel = $('.dyn-featured-properties').flickity({
            bgLazyLoad: 1,
            cellAlign: "left",
            wrapAround: true
        });
    }

    setFlickityForSimilarProperties = function () {
        //var $carousel = $('.dyn-similar-properties').flickity({
        //    bgLazyLoad: 1,
        //    cellAlign: "left",
        //    wrapAround: true
        //});

        var centreMode = false;
        var centerPadding = '50px';
        if ($(window).width() > 1499) {
            centreMode = true;
            centerPadding = '500px';
        } else if ($(window).width() > 1223) {
            centreMode = true;
            centerPadding = '400px';
        } else if ($(window).width() > 1023) {
            centreMode = true;
            centerPadding = '300px';
        } else if ($(window).width() > 767) {
            centreMode = true;
            centerPadding = '200px';
        }

        $('.dyn-similar-properties').slick({
            accessibility: true,
            adaptiveHeight: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            arrows: false,
            dots: true,
            centerMode: centreMode,
            centerPadding: centerPadding
        });
    }

});
$(function () {

    var defaultLatitude = 54.974248;
    var defaultLongitude = -1.603980;

    var map;
    var mapLat = 54.974248;
    var mapLong = -1.603980;
    var mapZoom = 10;
    var mapRadius = 900;

    var panorama;
    var panoramaLat = 54.974248;
    var panoramaLong = -1.603980;
    var panoramaZoom = 1;

    //var centroidMarker;
    //var centroidCircle;
    //var centroidMarkerOptions = {};
    //var centroidCircleOptions = {};
    var minZoomLevel = 10;
    var maxZoomLevel = 18;

    var propertyMarkers = [];
    var propertyOutsideMarkers = [];
    var propertyInfoWindows = [];
    var trainMarkers = [];
    var schoolMarkers = [];

    mediaCheck = function () {
        var mediaCheck = document.getElementById('mediaCheck'),
            mediaStyles = window.getComputedStyle(mediaCheck),
            mediaDisplay = mediaStyles.getPropertyValue('display');
        return mediaDisplay;
    }

    mediaMapCheck = function () {
        var mediaMapCheck = document.getElementById('mediaMapCheck'),
            mediaMapStyles = window.getComputedStyle(mediaMapCheck),
            mediaMapDisplay = mediaMapStyles.getPropertyValue('display');
        return mediaMapDisplay;
    }

    mapIsReloading = function () {
        //var loading = document.createElement('div');
        //loading.id = "loading-wrapper";
        //loading.className = "alt";
        //var loader = document.createElement('div');
        //loader.className = "loading-icon alt";
        //loading.appendChild(loader);
        //$('body').append(loading.outerHTML);
        $('body').addClass('loading-active');
    }

    panMapToCoords = function (lat, lng) {
        console.log('panMapToCoords start');

        // if (mediaMapCheck() !== 'none') {

            if (!(lat > 0)) {
                lat = defaultLatitude;
                lng = defaultLongitude;
            }

            var geoLocation = new google.maps.LatLng(lat, lng);

            // Update map position
            map.panTo(geoLocation);
            map.setZoom(15);

            // Update position for the centroid
            //centroidMarkerOptions.position = geoLocation;
            //centroidMarker.setPosition(centroidMarkerOptions.position);

            //// Update position for the circle
            //var coords = centroidMarker.getPosition();
            ////if (coords.lat > 0) {
            //    centroidCircleOptions.center = coords;
            //    centroidCircle.setCenter(centroidCircleOptions.center);
            ////}
        // }        
    }

    setMapZoomLevel = function (mapZoom, mapRadius) {
        map.zoom = mapZoom;
        centroidCircleOptions.radius = mapRadius;
        centroidCircle.setRadius(centroidCircleOptions.radius);
    }

    // drawingMode: google.maps.drawing.OverlayType.POLYGON
    var drawingManager;
    var selectedPolygon;
    var currentPolygon;
    var geoFencePoints = [];

    setCurrentPolygon = function (shape) {
        currentPolygon = shape;
    }

    selectPolygon = function (shape) {
        selectedPolygon = shape;
        clearSelectedPolygon();
    }

    clearCurrentPolygon = function () {
        if (currentPolygon) {
            currentPolygon.setEditable(true);
            currentPolygon.setMap(null);
            currentPolygon = null;
        }
    }

    clearSelectedPolygon = function () {
        if (selectedPolygon) {
            selectedPolygon.setEditable(false);
            selectedPolygon.setMap(null);
            selectedPolygon = null;
        }
    }    

    resetDrawingMode = function () {
        $('.map-btn-add-polygon').removeClass("active");
        $('.map-btn-add-polygon-span').text('Draw a search');
        if (drawingManager != null && drawingManager != undefined) {
            drawingManager.setDrawingMode(null);
        }
    }

    displayClearPolygonButton = function () {
        $('.map-btn-clear-polygon').fadeIn(0);
    }

    hideClearPolygonButton = function () {
        $('.map-btn-clear-polygon').fadeOut(0);
    }

    loadPropertySearchMap = function () {
        console.log('loadPropertySearchMap start');
        var geoLocation = { lat: mapLat, lng: mapLong };
        // var geoLocation = new google.maps.LatLng(mapLat, mapLong);

        // Add the map
        map = new google.maps.Map(document.getElementById('property-search-map'), {
            zoom: mapZoom,
            center: geoLocation,
            streetViewControl: false,
            disableDoubleClickZoom: true
        });

        // Add office marker
        var officeMarkerIcon = {
            url: '/dist/images/bm-marker.png', // 'office.png'
            scaledSize: new google.maps.Size(34, 50), // size
        };
        var officeMarker = new google.maps.Marker({
            position: { lat: defaultLatitude, lng: defaultLongitude },
            // position: new google.maps.LatLng(defaultLatitude, defaultLongitude),
            map: map,
            // icon: '/dist/images/bm-marker.png',
            icon: officeMarkerIcon,
            animation: google.maps.Animation.BOUNCE
        });        
    }

    initMapDrawing = function (searchCallback) {
        console.log('initMapDrawing start');
        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            //drawingControlOptions: {
            //    position: google.maps.ControlPosition.RIGHT_CENTER,
            //    drawingModes: ['polygon']
            //},
            polygonOptions: {
                fillColor: '#2b3d66',
                fillOpacity: 0.4,
                strokeColor: '#2b3d66',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                clickable: false,
                draggable: false,
                editable: true,
                zIndex: 99
            }
        });
        drawingManager.setMap(map);

        // polygon:  Polygon
        google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
            google.maps.event.addListener(polygon, 'click', function () {
                selectPolygon(polygon);
            });
            polygon.getPaths().forEach(function (path, index) {
                google.maps.event.addListener(path, 'insert_at', function () {
                    console.log('New point');
                    setCurrentPolygonPaths();
                });
                google.maps.event.addListener(path, 'remove_at', function () {
                    console.log('Point was removed');
                    setCurrentPolygonPaths();
                });
                google.maps.event.addListener(path, 'set_at', function () {
                    console.log('Point was moved');
                    setCurrentPolygonPaths();
                });
            });

            clearCurrentPolygon();
            setCurrentPolygon(polygon);
            // resetDrawingMode();
            setCurrentPolygonPaths();
            displayClearPolygonButton();
        });

        setCurrentPolygonPaths = function () {
            geoFencePoints = [];
            if (currentPolygon) {
                var coordinates = (currentPolygon.getPath().getArray());
                coordinates.forEach(function (latLng) {
                    geoFencePoints.push({ latitude: latLng.lat(), longitude: latLng.lng() });
                })
            }
            searchCallback(geoFencePoints);
        }
    }

    forceResetPolygonDrawing = function () {
        console.log(`forceResetPolygonDrawing`);
        clearCurrentPolygon();
        hideClearPolygonButton();
        resetDrawingMode();
        geoFencePoints = [];
    }

    addPropertyMarker = function (p1) {
        if (p1.latitude != null && p1.latitude > 0) {

            // Add the property marker
            //var propertyMarker = new RichMarker({
            //    position: new google.maps.LatLng(p1.latitude, p1.longitude),
            //    draggable: false,
            //    map: map,
            //    content: '<div class="prop-marker-wrapper"><center><i class="fa fa-home" aria-hidden="true" title=\"click to view\"></i></center></div>',
            //    shadow: 0,
            //    anchor: RichMarkerPosition.MIDDLE,
            //    label: p1.referenceNumber
            //});

            var propertyMarkerIcon = {
                url: '/dist/images/property-marker.svg', // 'pin_bandm.png'
                scaledSize: new google.maps.Size(35, 35), // size
            };
            var propertyMarker = new google.maps.Marker({
                position: new google.maps.LatLng(p1.latitude, p1.longitude),
                map: map,
                icon: '/dist/images/property-marker.png',
                zIndex: 88
            });
            propertyMarker.setMap(map);

            // Form the info window
            var propertyInfoWindow = new google.maps.InfoWindow();
            google.maps.event.addListener(propertyMarker, 'click', function () {
                closeAllPropertyInfoWindows();

                // Is added to shortlist
                var isShortlisted = isPropertyShortlisted(p1.id);
                var isShortlistedClass = isShortlisted == true ? " icon-active" : " icon-inactive";

                // Property
                let isResidential = p1.isResidential;
                let isResidentialSale = p1.isResidentialSale;
                let isResidentialLetting = p1.isResidentialLetting;
                let isCommercial = p1.isCommercial;
                let isAgricultural = p1.isAgricultural;

                // Address
                var propAddress = p1.propertyAddress;

                var townPostcode = propAddress.lineTwo != null && propAddress.lineTwo.length > 0 ? propAddress.lineTwo : propAddress.town;
                townPostcode += townPostcode.length > 0 ? ", " : "";
                if (propAddress.town != null && propAddress.town.length > 0) {
                    townPostcode += propAddress.town;
                }
                townPostcode += townPostcode.length > 0 ? ", " : "";
                if (propAddress.postcode != null && propAddress.postcode.length > 0) {
                    townPostcode += propAddress.postcode;
                }

                // Residential
                var bathrooms = "";
                var bedrooms = "";
                var dimensions = "";
                var priceLabel = "";
                var priceValue = "";

                if (isResidential == true) {

                    // Beds and Bathrooms
                    bathrooms = "<li><i class=\"fas fa-bath\"></i> " + p1.bathrooms + "</li>";
                    bedrooms = "<li><i class=\"fas fa-bed\"></i> " + p1.bedrooms + "</li>";

                    // Dimensions
                    // dimensions = p1.residential.floorArea > 0 ? "<li><i class=\"fas fa-ruler-combined\"></i>" + p1.residential.floorArea + " " + p1.residential.floorAreaUnitsName + "</li>" : "";

                    // Sales
                    if (isResidentialSale == true) {
                        // Price
                        priceLabel = p1.priceQualifier != null && p1.priceQualifier.length > 0
                            ? p1.priceQualifier
                            : "Asking Price";
                        
                        priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
                    }

                    // Lettings
                    if (isResidentialLetting == true) {
                        // Price
                        // var priceTypeLabel = p1.residentialLetting.rentFrequencyName;
                        // var rentDisplayLabel = p1.residentialLetting.rentDisplay;
                        // if (p1.branchName == 'Student') { priceTypeLabel = " PPPW"; rentDisplayLabel = p1.residentialLetting.rentPppwDisplay; }

                        priceLabel = p1.priceQualifier != null && p1.priceQualifier.length > 0
                            ? p1.priceQualifier
                            : "Asking Price";
                        
                        if (p1.priceRent !== "") {
                            priceValue = p1.priceDisplay ? p1.priceFormatted  + " " + p1.priceRent : "POA";
                        } else {
                            priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
                        }

                        if (p1.priceDisplay && !!p1.students && p1.students === true) {
                            if (!!p1.pricePppwFormatted && p1.pricePppwFormatted !== "" && p1.pricePppwFormatted.length > 0) {
                                priceValue = p1.pricePppwFormatted + " PPPW";
                            }
                        }
                    }
                }

                if (isCommercial == true) {

                    // Dimensions
                    // var commercialFloorArea = "";
                    // var commercialSiteArea = "";

                    // FloorArea
                    // if (p1.commercial.floorAreaFrom != null && p1.commercial.floorAreaFrom > 0) {
                    //     commercialFloorArea += p1.commercial.floorAreaFrom;
                    // }
                    // if (p1.commercial.floorAreaTo != null && p1.commercial.floorAreaTo > 0) {
                    //     if (commercialFloorArea.length > 0) { commercialFloorArea += " to "; }
                    //     commercialFloorArea += p1.commercial.floorAreaTo + " " + p1.commercial.floorAreaUnitsName;
                    // }
                    // SiteArea
                    // if (p1.commercial.siteArea != null && p1.commercial.siteArea > 0) {
                    //     commercialSiteArea += p1.commercial.siteArea + " " + p1.commercial.siteAreaUnitsName;
                    // }

                    // dimensions = commercialFloorArea;
                    // if (commercialSiteArea.length > 0) {
                    //     if (dimensions.length > 0) {
                    //         dimensions += " (" + commercialSiteArea + ")";
                    //     } else {
                    //         dimensions = commercialSiteArea;
                    //     }
                    // }

                    // Price
                    priceLabel = p1.priceQualifier != null && p1.priceQualifier.length > 0
                        ? p1.priceQualifier
                        : "Asking Price";
                    
                    if (p1.priceRent !== "") {
                        priceValue = p1.priceDisplay ? p1.priceFormatted  + " " + p1.priceRent : "POA";
                    } else {
                        priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
                    }
                }

                if (isAgricultural == true) {

                    // Dimensions
                    // if (p1.agricultural.landAreaFrom != null && p1.agricultural.landAreaFrom > 0) {
                    //     dimensions += p1.agricultural.landAreaFrom;
                    // }
                    // if (p1.agricultural.landAreaTo != null && p1.agricultural.landAreaTo > 0) {
                    //     if (dimensions.length > 0) { dimensions += " to "; }
                    //     dimensions += p1.agricultural.landAreaTo + " " + p1.agricultural.landAreaUnitsName;
                    // }

                    // Price
                    priceLabel = p1.priceQualifier != null && p1.priceQualifier.length > 0
                        ? p1.priceQualifier
                        : "Asking Price";
                    
                    if (p1.priceRent !== "") {
                        priceValue = p1.priceDisplay ? p1.priceFormatted  + " " + p1.priceRent : "POA";
                    } else {
                        priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
                    }
                }

                priceLabel = p1.bedrooms + " Bedroom " + p1.typeOneFormatted;
                
                var asset = p1.propertyAsset != null && p1.propertyAsset.length > 0 ? p1.propertyAsset : null;
                var cdnUrl = window['__appConfig'].cdnUrl;

                var infoWindowContent = "<div class=\"info-box-wrapper\">";
                infoWindowContent += "      <div class=\"row listing-row\">";
                infoWindowContent += "          <div class=\"listing col-sm-12\">";

                if (asset != null) {
                    infoWindowContent += "              <div class=\"image col-sm-6\">";
                    infoWindowContent += "                  <div class=\"carousel-listing\">";
                    infoWindowContent += "                      <div class=\"carousel-cell-infobox\">";
                    infoWindowContent += "                          <a href=\"/property/" + p1.url + "\" class=\"map-infowindow-image-link\"><img src=\"" + asset +"\" alt=\"\" border=\"0\" /></a>";
                    infoWindowContent += "                      </div>";
                    infoWindowContent += "                  </div>";
                    infoWindowContent += "              </div>";
                }
                
                infoWindowContent += "              <div class=\"listing-details-wrapper col-sm-6\">";
                infoWindowContent += "                  <div class=\"listing-details\">";
                infoWindowContent += "                      <small>" + priceLabel + "</small>";
                infoWindowContent += "                      <h4>" + priceValue + "</h4>";
                infoWindowContent += "                      <p class=\"location\">" + propAddress.street + "</p>";
                infoWindowContent += "                      <p class=\"full-address\">" + townPostcode + "</p>";
                infoWindowContent += "                  </div>";
                infoWindowContent += "                  <div class=\"size\">";
                infoWindowContent += "                      <ul>";
                infoWindowContent +=                            dimensions;
                infoWindowContent +=                            bathrooms;
                infoWindowContent +=                            bedrooms;
                infoWindowContent += "                      </ul>";
                infoWindowContent += "                  </div>";
                infoWindowContent += "              </div>";
                infoWindowContent += "          </div>";
                infoWindowContent += "      </div>";
                infoWindowContent += "</div>";

                propertyInfoWindow.setContent(infoWindowContent);
                propertyInfoWindow.open(map, this);
            });
            propertyInfoWindows.push(propertyInfoWindow);

            /*google.maps.event.addListener(propertyMarker, 'mouseover', function () {
                propertyMarker.setIcon('/dist/images/ping_bandm.png');
            });
            google.maps.event.addListener(propertyMarker, 'mouseout', function () {
                propertyMarker.setIcon('/dist/images/pin_bandm.png');
            });*/

            // Add to array for clean up
            propertyMarkers.push(propertyMarker);
        }

        function isPropertyShortlisted(id) {
            var lsShortlist = [];
            var lsShortlistStr = localStorage.getItem("bm-pty-short");
            if (lsShortlistStr != null && lsShortlistStr != undefined) {
                lsShortlist = JSON.parse(lsShortlistStr);
            }
            var lsShortlistd = _.indexOf(lsShortlist, id);
            return lsShortlistd > -1;
        }
    }

    addPropertyOutsideMarker = function (p1) {
        if (1 === 2 && p1.latitude != null && p1.latitude > 0) {
            // Add the property marker
            //var propertyOutsideMarker = new RichMarker({
            //    position: new google.maps.LatLng(p1.latitude, p1.longitude),
            //    draggable: false,
            //    map: map,
            //    content: '<div class="prop-outside-marker-wrapper"><center><i class="fa fa-home" aria-hidden="true" title=\"property outside of search area\"></i></center></div>',
            //    shadow: 0,
            //    anchor: RichMarkerPosition.MIDDLE,
            //});
            var propertyOutsideMarkerIcon = {
                url: '/dist/images/property-marker.svg', // 'pin_bandm.png'
                scaledSize: new google.maps.Size(35, 35), // size
            };
            var propertyOutsideMarker = new google.maps.Marker({
                position: new google.maps.LatLng(p1.latitude, p1.longitude),
                map: map,
                icon: '/dist/images/property-marker-out.png',
                zIndex: 80
            });
            propertyOutsideMarker.setMap(map);

            /*google.maps.event.addListener(propertyOutsideMarker, 'mouseout', function () {
                propertyOutsideMarker.setIcon('/dist/images/ping_bandm.png');
            });
            google.maps.event.addListener(propertyOutsideMarker, 'mouseover', function () {
                propertyOutsideMarker.setIcon('/dist/images/pin_bandm.png');
            });*/

            // Add to array for clean up
            propertyOutsideMarkers.push(propertyOutsideMarker);
        }
    }

    setPropertyMarkerClusters = function () {
        //var markerCluster = new MarkerClusterer(map, propertyMarkers,
        //{ imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });

        //var markerOutsideCluster = new MarkerClusterer(map, propertyOutsideMarkers,
        //{ imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });
    }

    clearPropertyMarkers = function () {
        console.log('clearPropertyMarkers start');
        closeAllPropertyInfoWindows();

        if (propertyMarkers.length > 0) {
            for (var i = 0; i < propertyMarkers.length; i++) {
                propertyMarkers[i].setMap(null);
            }
        }
        propertyMarkers = [];

        if (propertyOutsideMarkers.length > 0) {
            for (var i = 0; i < propertyOutsideMarkers.length; i++) {
                propertyOutsideMarkers[i].setMap(null);
            }
        }
        propertyOutsideMarkers = [];
    }

    closeAllPropertyInfoWindows = function () {
        console.log('closeAllPropertyInfoWindows start');
        if (propertyInfoWindows.length > 0) {
            for (var i = 0; i < propertyInfoWindows.length; i++) {
                propertyInfoWindows[i].close();
            }
        }
    }

    initPropertySearchMap = function (lat, lng, zoom, radius, searchCallback) {
        console.log('lat: ' + lat + ' lng: ' + lng + ' zoom: ' + zoom + ' radius: ' + radius);
        mapLat = lat;
        mapLong = lng;
        mapZoom = zoom;
        mapRadius = radius;

        if (!(mapLat > 0)) {
            mapLat = defaultLatitude;
            mapLong = defaultLongitude;
        }

        loadPropertySearchMap();
        initMapDrawing(searchCallback);

        /*if (mediaMapCheck() !== 'none') {
            loadPropertySearchMap();
            initMapDrawing(searchCallback);
        } else {
            hidePropertySearchMap();
        } */
    }

    hidePropertySearchMap = function () {
        $('.dyn-map-visibility').fadeOut(0);
    }

    loadTrainMarkers = function () {
        $.getJSON("/dist/json/train_station_global.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-train-marker"><center><i class="fa fa-train" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    trainMarkers.push(specialMarker);
                }
            });
        });
        $.getJSON("/dist/json/subway_station_newcastle.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-train-marker"><center><i class="fa fa-subway" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    trainMarkers.push(specialMarker);
                }
            });
        });
        $.getJSON("/dist/json/subway_station_gateshead.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-train-marker"><center><i class="fa fa-subway" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    trainMarkers.push(specialMarker);
                }
            });
        });
        $.getJSON("/dist/json/subway_station_tynemouth.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-train-marker"><center><i class="fa fa-subway" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    trainMarkers.push(specialMarker);
                }
            });
        });
        $.getJSON("/dist/json/subway_station_ponteland.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-train-marker"><center><i class="fa fa-subway" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    trainMarkers.push(specialMarker);
                }
            });
        });
    }

    loadSchoolMarkers = function () {
        $.getJSON("/dist/json/school_newcastle.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-school-marker"><center><i class="fa fa-graduation-cap" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    schoolMarkers.push(specialMarker);
                }
            });
        });
        $.getJSON("/dist/json/school_gateshead.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-school-marker"><center><i class="fa fa-graduation-cap" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    schoolMarkers.push(specialMarker);
                }
            });
        });
        $.getJSON("/dist/json/school_ponteland.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-school-marker"><center><i class="fa fa-graduation-cap" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    schoolMarkers.push(specialMarker);
                }
            });
        });
        $.getJSON("/dist/json/school_tynemouth.json", function (data) {
            $.each(data.results, function (i, item) {
                var clat = item.geometry.location.lat;
                var clng = item.geometry.location.lng;
                if (clat != null && clng != null) {
                    var specialMarker = new RichMarker({
                        position: new google.maps.LatLng(clat, clng),
                        draggable: false,
                        map: map,
                        content: '<div class="special-school-marker"><center><i class="fa fa-graduation-cap" aria-hidden="true" title=\"' + item.name + '\"></i></center></div>',
                        shadow: 0,
                        anchor: RichMarkerPosition.MIDDLE,
                    });
                    specialMarker.setMap(map);
                    schoolMarkers.push(specialMarker);
                }
            });
        });
    }

    clearTrainMarkers = function () {
        if (trainMarkers.length > 0) {
            for (var i = 0; i < trainMarkers.length; i++) {
                trainMarkers[i].setMap(null);
            }
        }
        trainMarkers = [];
    }

    clearSchoolMarkers = function () {
        if (schoolMarkers.length > 0) {
            for (var i = 0; i < schoolMarkers.length; i++) {
                schoolMarkers[i].setMap(null);
            }
        }
        schoolMarkers = [];
    }

    loadPropertyMap = function () {
        console.log('loadPropertyMap start');
        var geoLocation = { lat: mapLat, lng: mapLong };

        // Add the map
        map = new google.maps.Map(document.getElementById('primary-map'), {
            zoom: mapZoom,
            center: geoLocation
        });

        // Add the marker
        //var propertyMarker = new RichMarker({
        //    position: new google.maps.LatLng(mapLat, mapLong),
        //    draggable: false,
        //    map: map,
        //    content: '<div class="prop-marker-wrapper-lrg"><center><i class="fa fa-home" aria-hidden="true"></i></center></div>',
        //    shadow: 0,
        //    anchor: RichMarkerPosition.MIDDLE
        //});
        var propertyMarkerIcon = {
            url: '/dist/images/property-marker.svg', // 'pin_bandm.png'
            scaledSize: new google.maps.Size(35, 35), // size
        };
        var propertyMarker = new google.maps.Marker({
            position: new google.maps.LatLng(mapLat, mapLong),
            map: map,
            icon: '/dist/images/property-marker.png',
            zIndex: 88
        });
        propertyMarker.setMap(map);
    }

    initPropertyMap = function (lat, lng, zoom) {
        console.log('lat: ' + lat + ' lng: ' + lng + ' zoom: ' + zoom);
        mapLat = lat;
        mapLong = lng;
        mapZoom = zoom;

        loadPropertyMap();
    }

    loadPropertyStreetView = function () {
        console.log('loadPropertyStreetView start');
        var geoLocation = { lat: panoramaLat, lng: panoramaLong };

        // Add the street view view
        panorama = new google.maps.StreetViewPanorama(
            document.getElementById('primary-street-view'),
            {
                position: geoLocation,
                pov: { heading: 0, pitch: 0 },
                zoom: panoramaZoom
            });
    }

    initPropertyStreetView = function (lat, lng, zoom) {
        console.log('lat: ' + lat + ' lng: ' + lng + ' zoom: ' + zoom);
        panoramaLat = lat;
        panoramaLong = lng;
        panoramaZoom = zoom;

        loadPropertyStreetView();
    }

    $('.map-btn-display').click(function (e) {
        e.preventDefault();

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $('.dyn-map-visibility').fadeOut(0);
        } else {
            $(this).addClass("active");
            $('.dyn-map-visibility').fadeIn(0);
        }        
    });

    $('.map-btn-clear-polygon').click(function (e) {
        e.preventDefault();
        clearCurrentPolygon();
        setCurrentPolygonPaths();
        hideClearPolygonButton();
    });

    $('.map-btn-add-polygon').click(function (e) {
        e.preventDefault();

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $('.map-btn-add-polygon-span').text('Draw a search');
            drawingManager.setDrawingMode(null);
        } else {
            $(this).addClass("active");
            $('.map-btn-add-polygon-span').text('Stop drawing');
            drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
        }
    });

    $('.map-btn-add-poi').click(function (e) {
        e.preventDefault();

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $('.action-button-child').each(function () {
                $(this).fadeOut(1000);
                $(this).css('display', 'none');
            });
        } else {
            $(this).addClass("active");
            $('.action-button-child').each(function () {
                $(this).fadeIn(1000);
                $(this).css('display', 'block');
            });
        }
    });

    $('.map-btn-ctr-trains').click(function (e) {
        e.preventDefault();

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            clearTrainMarkers();
        } else {
            $(this).addClass("active");
            loadTrainMarkers();
        }
    });

    $('.map-btn-ctr-schools').click(function (e) {
        e.preventDefault();

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            clearSchoolMarkers();
        } else {
            $(this).addClass("active");
            loadSchoolMarkers();
        }
    });

    $(document).on('click', '.search-lookup-locality', function (e) {
        // Doubling up on event call here to remove polygon
        forceResetPolygonDrawing();
    });
});
$(function () {

    // Search bar interactions START

    var baseLat = 54.97948550174384;
    var baseLng = -1.6116876497918708;
    var baseRadius = 20000;
    var typeRegion = 1;

    /**
     model:
         place_id
         type_id [1 = regions, 2 = schools, 3 = train station, 4 = current location, 5 = static terms]
         name
         lat
         lng
     */

    var placeMatches = [];
    var selectedLocalities = [];

    var placePlacesLookup = function (terms, renderCallback) {

        terms = terms.toLowerCase();

        // Create a new session token.
        var sessionToken = new google.maps.places.AutocompleteSessionToken();

        // Create service options and restrictions
        var options = {
            types: ['(regions)'],
            componentRestrictions: { country: ["uk"] },
            input: terms,
            location: new google.maps.LatLng(baseLat, baseLng),
            radius: baseRadius,
            sessionToken: sessionToken
        };

        // Callback method to display results to UI
        var displaySuggestions = function (predictions, status) {
            $('#place-results').html('');
            if (status != google.maps.places.PlacesServiceStatus.OK) {
                console.log('places lookup failed: ' + status);
                return;
            }

            predictions.forEach(function (item) {
                var x = _.find(placeMatches, ['place_id', item.place_id]);
                if (x == null) {
                    placeMatches.push({
                        place_id: item.place_id,
                        type_id: typeRegion,
                        name: item.description,
                        vicinity: item.vicinity,
                        types: item.types,
                        structured_formatting: item.structured_formatting, // main_text
                        lat: 0,
                        lng: 0
                    });
                }                
            });

            renderCallback();
        };

        // Call the service
        var acService = new google.maps.places.AutocompleteService();
        acService.getQueryPredictions(options, displaySuggestions);
    }
    
    var displayPlacePlacesLookup = function () {
        
        $('#psearch-picker-locality-select')
        .empty()
        .append('<option value="-1" disabled>Search location</option>');

        if (placeMatches.length > 0) {
            $('#psearch-picker-locality-select')
            .append('<option value="0">Please select your search location</option>');

            placeMatches.forEach(function (item) {
                var t1Sel = ""; // "route", "sublocality", "locality", "postal_code"
                if (item.types != null && item.types != "") {
                    item.types.forEach(function (t1) {
                        if (t1Sel == "") {
                            if (t1 == "route") {
                                t1Sel = t1;
                            } else if (t1 == "sublocality") {
                                t1Sel = t1;
                            } else if (t1 == "locality") {
                                t1Sel = t1;
                            } else if (t1 == "postal_code") {
                                t1Sel = t1;
                            } else if (t1 == "school") {
                                t1Sel = t1;
                            } else if (t1 == "train_station") {
                                t1Sel = t1;
                            } else if (t1 == "establishment") {
                                t1Sel = t1;
                            } 
                        }
                    });
                }
                var _vicinity = '';
                if (item.vicinity !== null && item.vicinity !== undefined && item.vicinity.length > 0) {
                    _vicinity = item.vicinity.replace(/[^a-z0-9, ]/gi, '');
                }
                var _main_text = '';
                if (item.structured_formatting !== null && item.structured_formatting !== undefined) {
                    if (item.structured_formatting.main_text !== null && item.structured_formatting.main_text !== undefined && item.structured_formatting.main_text.length > 0) {
                        _main_text = item.structured_formatting.main_text.replace(/[^a-z0-9, ]/gi, '');
                    }
                }

                $('#psearch-picker-locality-select')
                .append("<option value=\"" + item.place_id + "\" data-place-id=\"" + item.place_id + "\" data-type-id=\"" + item.type_id + "\" data-lat=\"" + item.lat + "\" data-lng=\"" + item.lng + "\" data-main-text=\"" + _main_text + "\" data-loc-name=\"" + item.name.replace(/[^a-z0-9, ]/gi, '') + "\" data-vicinity=\"" + _vicinity + "\" data-scope=\"" + t1Sel +"\">"+ item.name +"</option>");
            });
            
            $('.psearch-picker-locality').fadeIn(100);
            $('.psearch-picker-locality').parent().addClass("active-zone");
            $('.search-options').addClass('active-filter');
        }
    }

    addPill = function (data, actionSource) {
        var pillItem = _.find(selectedLocalities, ['place_id', data.place_id]);
        if (pillItem == null) {
            
            if (actionSource === 1) {
                $('#hdnNewPillAddedSinceSearch').val(1);
            } else {
                var newPillAddedSinceSearch = parseInt($('#hdnNewPillAddedSinceSearch').val().toString());
                if (newPillAddedSinceSearch === 1) {
                    return;
                }
            }

            // Remove old pill before replacing it
            selectedLocalities = [];
            $('#psearch-geo-locations').html('');

            // Push new item to array
            selectedLocalities.push(data);

            var _name = data.name.replace(/[^a-z0-9, ]/gi, '');
            var _vicinity = '';
            if (data.vicinity !== null && data.vicinity !== undefined && data.vicinity.length > 0) {
                _vicinity = data.vicinity.replace(/[^a-z0-9, ]/gi, '');
            }
            var _main_text = '';
            if (data.mainText !== null && data.mainText !== undefined && data.mainText.length > 0) {
                _main_text = data.mainText.replace(/[^a-z0-9, ]/gi, '');
            }

            // Used purely to store gei lookup data
            var pill = "<span title=\"" + _name + "\" class=\"data-place-item\" data-place-id=\"" + data.place_id + "\" data-type-id=\"" + data.type_id + "\" data-lat=\"" + data.lat + "\" data-lng=\"" + data.lng + "\" data-main-text=\"" + _main_text + "\" data-loc-name=\"" + _name + "\" data-vicinity=\"" + _vicinity + "\" data-scope=\"" + data.scope + "\"></span>";
            $(pill).appendTo('#psearch-geo-locations');

            $('#psearch-locality').val(_main_text);
        }
    }

    removePill = function () {
        removeAllPills();
    }

    removeAllPills = function () {
        $('#psearch-locality').val('');
        $('#psearch-geo-locations').html('');
        selectedLocalities = [];
    }

    attemptLocationMatchPartial = function (location, callback) {
        var terms = location.toLowerCase();

        // Create a new session token.
        var sessionToken = new google.maps.places.AutocompleteSessionToken();

        // Create service options and restrictions
        var options = {
            types: ['(regions)'],
            componentRestrictions: { country: ["uk"] },
            input: terms,
            location: new google.maps.LatLng(baseLat, baseLng),
            radius: baseRadius,
            sessionToken: sessionToken
        };

        var firstPlaceDetails = function (item, status) {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
                _lat = item.geometry.location.lat();
                _lng = item.geometry.location.lng();
                callback(_lat, _lng);
            }
        };

        // Callback method to display results to UI
        var pickSuggestion = function (predictions, status) {
            if (status != google.maps.places.PlacesServiceStatus.OK) {
                callback(baseLat, baseLng);
            }
            if (predictions.length == 0) {
                callback(baseLat, baseLng);
            }
            // Use place_id to get Geometry
            var lookupPlace = {
                placeId: predictions[0].place_id,
                fields: ['name', 'rating', 'geometry']
            };
            var psService = new google.maps.places.PlacesService($('#place-item-working-area').get(0));
            psService.getDetails(lookupPlace, firstPlaceDetails);
        };
        
        // Call the service
        var acService = new google.maps.places.AutocompleteService();
        acService.getQueryPredictions(options, pickSuggestion);
    }

    $('#psearch-locality').keydown(function (e) {
        if (e.which == 13 || e.keyCode === 10 || e.keyCode === 13) {
            e.preventDefault();
        }
    });

    $('#psearch-locality').keyup(function (e) {
        if (e.which == 13 || e.keyCode === 10 || e.keyCode === 13) {
            e.preventDefault();
        }

        var searchString = $('#psearch-locality').val().toString();
        placeMatches = [];

        if (searchString !== '' && searchString.length > 2) {
            placePlacesLookup(searchString, displayPlacePlacesLookup);
        } else {
            displayPlacePlacesLookup();
        }
    });

    $(document).on('keypress', '#psearch-locality', function () {
        if ($(this).val().length > 0) {
            $('#psearch-locality-clear').css({ 'display': 'block' });
        }
    });

    $("#filterTrigger").on('click', function (e) {
        $("html, body").addClass("no-scroll");
        $("#psearch-fx").addClass("mobile-filters-active");
    });

    //$(document).on('focus', '#psearch-locality', function () {
    //    var isFilterHidden = document.getElementById("filterTrigger").style.display == "none";
    //    if (isFilterHidden == false) {
    //        $("html, body").addClass("no-scroll");
    //        $("#psearch-fx").addClass("mobile-filters-active");
    //    }
    //});

    $(document).on('click', '.psearch-locality-remove', function (e) {
        e.preventDefault();
        removePill();
    });

    // Search keywords
    selectLocalityFilter = function () {
        var placeId = parseInt($('#psearch-picker-locality-select').val().toString());
        if (placeId === -1 || placeId === 0) {
            removeAllPills();
        } else {
            var locality = $("#psearch-picker-locality-select option:selected");

            var _id = locality.attr("data-place-id");
            var _typeid = locality.attr("data-type-id");
            var _lat = locality.attr("data-lat");
            var _lng = locality.attr("data-lng");
            var _name = locality.attr('data-loc-name');
            var _scope = locality.attr('data-scope');
            var _vicinity = locality.attr('data-vicinity');
            var _main_text = locality.attr('data-main-text');
            // console.log("_id, _typeid, _name, _lat, _lng: " + _id + ", " + _typeid + ", " + _name + ", " + _scope + ", " + _vicinity + ", " + _main_text + ", " + _lat + ", " + _lng);

            if (_typeid == typeRegion) {
                // Use place_id to get Geometry
                var lookupPlace = {
                    placeId: _id,
                    fields: ['name', 'rating', 'geometry']
                };
                var psService = new google.maps.places.PlacesService($('#place-item-working-area').get(0));
                psService.getDetails(lookupPlace, setGeometry);
            } else {
                // Geometry already present
                // Add the pill to the search bar
                addPill({
                    place_id: _id,
                    type_id: _typeid,
                    name: _name,
                    vicinity: _vicinity,
                    mainText: _main_text,
                    scope: _scope,
                    lat: _lat,
                    lng: _lng
                }, 1);
            }

            function setGeometry(item, status) {
                if (status == google.maps.places.PlacesServiceStatus.OK) {
                    // Set the geometry long and lat
                    _lat = item.geometry.location.lat();
                    _lng = item.geometry.location.lng();

                    // Add the pill to the search bar
                    addPill({
                        place_id: _id,
                        type_id: _typeid,
                        name: _name,
                        vicinity: _vicinity,
                        mainText: _main_text,
                        scope: _scope,
                        lat: _lat,
                        lng: _lng
                    }, 1);
                }
            }        
        }

        $('.psearch-zone').fadeOut(0);
        $('.psearch-container').removeClass("active-zone");
        $('.search-options-filters').removeClass("active-zone");
        $('.search-options').removeClass('active-filter');
    }
    $('#psearch-picker-locality-select').change(function (e) {
        selectLocalityFilter();
    });

});

$(function () {
    /**
    * forEach implementation for Objects/NodeLists/Arrays, automatic type loops and context options
    *
    * @private
    * @author Todd Motto
    * @link https://github.com/toddmotto/foreach
    * @param {Array|Object|NodeList} collection - Collection of items to iterate, could be an Array, Object or NodeList
    * @callback requestCallback      callback   - Callback function for each iteration.
    * @param {Array|Object|NodeList} scope=null - Object/NodeList/Array that forEach is iterating over, to use as the this value when executing callback.
    * @returns {}
    */
    var forEach = function (t, o, r) { if ("[object Object]" === Object.prototype.toString.call(t)) for (var c in t) Object.prototype.hasOwnProperty.call(t, c) && o.call(r, t[c], c, t); else for (var e = 0, l = t.length; l > e; e++)o.call(r, t[e], e, t) };

    var hamburgers = document.querySelectorAll(".hamburger-box");
    if (hamburgers.length > 0) {
        forEach(hamburgers, function (hamburger) {
            hamburger.addEventListener("click", function () {
                this.parentNode.classList.toggle("is-active");
            }, false);
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./Source/js/build/Lib.js
// module id = 5
// module chunks = 0